var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeSplashAqua1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "7.79605cm",
    height: "9.4977cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 2038.73 2483.73",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Conte\\xFAdo_x0020_do_x0020_PowerClip"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2623434414768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2608583901504"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1876.99 2338.56c4.7,-2.39 9.64,-3.54 16.53,-1.54 6.46,3.52 8.37,8.43 9.81,13.42 2.6,9.11 -1.2,19.08 -8.14,22.32 -7.64,3.68 -16.27,0.48 -21.62,-8.09 -1.35,-2.2 -2.59,-4.49 -3.63,-6.84 -3.63,-8.45 -1.18,-15.11 7.05,-19.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1706.11 2284.61c0.14,1.51 -1.08,3.21 -3.06,5.85 -2.23,1.31 -3.01,1.75 -3.82,1.77 -10.66,0.31 -14.54,-2.09 -14.54,-8.87 0.04,-7.13 4.4,-12.59 10.08,-12.59 6.76,0.01 10.27,4.1 11.34,13.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M890.01 1014.66c3.99,9.47 12.92,9.48 20.55,11.07 15.95,3.35 26.8,12.74 34.54,26.59 2.02,3.58 3.97,7.23 6,10.82 1.49,2.61 3.96,3.63 7.96,3.53 0.06,-0.02 0.12,0 0.16,-0.01 -0.27,-0.18 -0.58,-0.36 -0.86,-0.6 3.97,-2.73 6.99,-2.9 7.6,1.42 0.77,0.33 1.57,0.73 2.48,1.17 3.89,1.96 6.52,3.1 10.34,4.67 0.1,0.05 0.16,0.11 0.26,0.16 -0.18,-0.33 -0.39,-0.65 -0.53,-0.99 3.88,0.09 6.71,0.96 6.2,4.54 0.68,0.43 1.4,0.88 2.24,1.34 2.82,0.8 4.44,1.25 7.08,2.38 0.06,0.04 0.12,0.1 0.18,0.15 -0.11,-0.45 -0.24,-0.85 -0.29,-1.3 4.61,0.63 5.66,3.24 4.57,6.31 0.39,0.87 0.78,1.82 1.06,2.96 1.67,6.86 -1.97,10.95 -4.44,14.73 -3.62,5.52 -7.03,10.17 -2.75,16.76 0.48,0.74 -1.36,4.08 -2.83,4.91 -2.45,1.36 -5.28,0.96 -7.15,-1.79 -2.14,-3.2 -2.43,-8.55 -8.22,-7.55 -4.38,0.7 -7.3,3.64 -9.68,7.28 -1.89,2.94 -4.38,5.62 -5.72,8.76 -3.2,7.21 -8.1,11.24 -16.07,10.74 -4.9,-0.32 -8.35,2.12 -9.06,6.72 -2.83,18.06 -16.21,28.37 -27.94,40.06 -5.17,5.16 -11.15,5.24 -17.3,3.93 -3.27,-0.73 -6.24,-2.8 -9.45,-4.06 -5.32,-2.06 -10.15,-2.28 -15.55,1.38 -9.72,6.64 -19.76,12.45 -32.65,9.78 -4.67,-0.99 -9.07,3.42 -10.09,8.86 -1.39,7.42 -0.09,15.83 -6.83,21.31 -6.45,5.18 -14.76,2.09 -22.11,4.09 -6.76,1.88 -10.15,-3.16 -7.12,-9.82 1.7,-3.76 4.19,-7.17 6.45,-10.69 9.86,-15.35 8.88,-33.8 -2.53,-47.94 -2.15,-2.67 -3.99,-5.63 -6.17,-8.28 -6.23,-7.53 -12.76,-14.42 -23.72,-14.65 -7.28,-0.17 -10.84,-5.46 -11.87,-12.27 -0.59,-4.07 -0.61,-8.32 -0.54,-12.44 0.07,-2.99 1.73,-6.18 4.47,-6.3 10.26,-0.48 11.91,-10.87 18.41,-15.56 5.62,-4.04 7.63,-9.77 6.01,-16.64 -2.26,-9.86 2.63,-17.86 7.57,-25.38 4.55,-6.95 10.37,-13.01 18.44,-18.26 -0.18,-0.1 -0.36,-0.19 -0.55,-0.33 -1.55,-2.94 -2.8,-4.57 -4.41,-5.7 -2.97,-2.1 -4.83,-4.51 -3.59,-8.44 1.39,-4.21 4.25,-6.84 8.45,-7.92 4.82,-1.25 9.95,2.15 9.97,7 0.02,4.11 -1.97,8.35 -0.3,12.82 0.97,0.13 1.95,0.29 3.03,0.5 10.75,-2.2 20.05,-4.3 30.54,-6.84 0.14,-0.03 0.25,-0.05 0.39,-0.11 -0.38,-0.13 -0.76,-0.22 -1.12,-0.38 3.19,-3.17 5.96,-4.16 7.55,-0.6 0.86,0.07 1.8,0.21 2.83,0.42 5.04,0.83 8.01,-0.53 11.04,-2.47 5.82,-3.69 11.88,-7.05 17.88,-10.42 2.48,-1.37 5.89,-2.53 7.17,0.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M976.24 1943.12c5.17,-7.42 10.69,-14.78 14.67,-22.87 4.29,-8.85 11.27,-14.65 19.11,-18.73 12.24,-6.38 25.14,-11.42 39.13,-13.24 12.84,-1.67 22.79,3.52 32.16,10.76 4.88,3.79 8.68,9 13.74,12.42 10.13,6.93 13.78,17.46 14.73,28.56 0.76,8.81 1.05,18.07 -1.38,27.06 -3.5,12.77 -6.47,25.72 -10.35,40.18 -8.63,18.72 -23.57,29.22 -37.05,41.39 -9.62,8.72 -20.58,11.39 -32.42,11.54 -8.19,0.1 -16.43,-0.86 -24.65,-1.2 -11.18,-0.44 -21.25,-5.17 -25.91,-17.11 -2.77,-7.07 -5.35,-14.36 -9.32,-20.76 -11.94,-19.44 -12.38,-38.98 -2.25,-59.54 3.08,-6.28 5.75,-12.69 9.79,-18.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1218.81 2163c-1.08,5.18 -1.47,8.74 -2.7,11.97 -6.66,18.61 -15.99,34.7 -33.78,45.57 -11.44,7 -22.6,6.99 -34.97,7.91 -12.79,0.95 -21.13,-3.36 -28.51,-12.28 -4.82,-5.84 -9.72,-11.63 -13.97,-17.88 -3.28,-4.84 -6.53,-10.44 -6.02,-16.39 0.92,-10.91 0.95,-22.01 4.52,-32.66 7.81,-23.17 19.79,-43.13 42.24,-54.58 20.4,-10.38 41.73,-7.45 59.34,12.11 13.95,15.48 16.94,34.21 13.85,56.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1188.64 1404.33c2.4,12.59 0.9,26.52 -8.66,37.63 -3.14,3.67 -5.72,7.9 -8.44,11.91 -8.31,12.19 -17.39,23.53 -31.29,29.74 -1.8,0.84 -4.12,2.11 -4.7,3.74 -1.45,4.05 -2.71,5.75 -6.58,2.37 -1.43,-1.22 -3.83,-1.78 -5.8,-1.77 -19.78,-0.09 -30.83,-11.7 -39.16,-28.3 -3.2,-6.43 -5.39,-12.49 -5.64,-19.63 -0.38,-10.07 1.65,-19.47 6.77,-28.14 5.04,-8.58 8.02,-17.72 9.39,-27.58 0.69,-4.77 2.75,-9.36 5.13,-15.36 0.2,-0.29 0.43,-0.49 0.64,-0.76 -0.46,0.11 -0.92,0.27 -1.38,0.35 0.92,-4.71 1.64,-8 3.02,-11.71 -0.63,-0.12 -1.26,-0.29 -1.98,-0.5 -10.11,0.05 -10.54,-8.76 -18.54,-13.85 7.14,-0.59 10.67,-2.52 13.94,-4.95 5.35,-3.99 11.74,-6.44 16.97,-2.35 4.77,3.74 1.39,9.79 0.02,16.28 0.43,-0.11 0.82,-0.23 1.27,-0.34 5.95,2.14 12.15,1.83 11.52,8.99 0.93,0.38 1.83,0.69 2.79,1.16 3.92,1.61 6.56,2.97 9.19,2.89 10.93,-0.41 20.06,4.84 29.23,9.3 12.59,6.12 19.89,18.21 22.3,30.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M709.86 690.52c-0.08,-0.07 -0.15,-0.09 -0.24,-0.15 1.94,-3.1 3.93,-4.11 5.92,-2.86 0.89,-0.19 1.84,-0.32 2.92,-0.44 4.67,-1.98 8.16,-3.27 13.31,-5.19 0.28,-0.01 0.54,-0.07 0.82,-0.12 -0.54,-0.17 -1.1,-0.3 -1.63,-0.52 5.9,-4.61 11.55,-1.2 16.72,-2.8 2.76,-0.83 3.84,-3.43 1.86,-5.99 -0.82,-1.04 -2.18,-1.68 -3,-2.72 -6.02,-7.95 -4.48,-13.07 5.08,-17.09 3.34,-1.4 6.54,-2.13 9.22,1.07 2.78,3.38 4.12,7.12 1.98,11.35 -1.78,3.6 -6.22,6.18 -5.16,10.7 1.32,5.53 7.07,5.51 11.15,7.57 1.8,0.89 4.01,1.32 5.36,2.65 1.95,1.92 2.58,4.42 -0.81,6.24 0.47,0.69 0.92,1.33 1.35,2.06 0.97,3.34 1.63,5.58 3.45,8.73l0 0.01c0.08,-0.31 0.09,-0.63 0.21,-0.93 5.42,-0.21 9.42,-0.62 13.46,-0.49 0.86,0.05 2.26,1.73 2.42,2.82 0.18,1.17 -0.53,3.34 -1.37,3.64 -3.98,1.47 -8.09,2.5 -12.51,2.77 -0.29,0.94 -0.78,1.94 -1.54,3.07 -1.6,5.81 -2.14,10.07 -3.77,13.85 -4.22,9.62 -4,18.15 1.97,27.33 4.73,7.29 2.76,12.98 -4.48,17.73 -5.15,3.43 -10.72,6.55 -16.53,8.45 -10.59,3.52 -20.78,-0.24 -26.57,-9.84 -3.87,-6.41 -9.48,-11.94 -11.04,-19.65 -0.93,-4.5 -4.06,-6.87 -7.24,-9.59 -6.52,-5.64 -14.03,-8.2 -22.44,-9.19 -5.16,-0.62 -6.41,-3.61 -5.38,-9.02 2.97,-15.44 10.74,-26.96 26.5,-33.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M555.32 223.19c-10.5,-0.08 -20.63,0.94 -29.93,-8.44 -9.44,-9.52 -21.84,-15.97 -27.33,-29.36 -0.67,-1.66 -3.33,-2.34 -4.8,-3.79 -2.97,-2.87 -6.08,-5.65 -8.55,-8.93 -4.89,-6.45 -6.05,-14.07 -3.01,-21.52 2.63,-6.38 9.74,-3.74 14.72,-5.62 4.27,-1.59 7.98,1.02 13.44,2.17 10.73,-1.45 16.63,4.38 19.48,11.2 3.39,7.82 8.8,10.33 15.93,10.22 8.94,-0.18 15.75,4.64 22.87,8.49 15.3,8.27 15.82,32.7 0.9,41.43 -4.05,2.36 -9.14,4.18 -13.73,4.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1064.83 1170.74c1.05,6.99 1.12,13.51 -3.12,20.07 -5.32,8.18 -4.76,8.5 4.65,12.19 2.56,0.98 5.21,1.85 7.58,3.18 8.19,4.61 10.51,12.22 7.5,21.26 -3.96,11.95 -14.12,16.37 -23.97,21.26 -2.64,1.33 -5.28,-0.42 -7.74,-1.77 -12.4,-6.81 -15.37,-23.61 -6.09,-35.98 2.8,-3.7 10.81,-4.7 9.14,-9.88 -2.42,-7.48 -9.58,-0.46 -14.46,-2.06 -3.89,-1.3 -7.88,-2.17 -13.07,-3.91 -0.07,-0.08 -0.15,-0.14 -0.22,-0.19 -0.05,0.25 -0.05,0.45 -0.12,0.73 -8.64,0.07 -15.8,0.31 -23.03,-0.83 -0.29,0.85 -0.72,1.68 -1.28,2.63 -3.04,5.81 -7.3,8.09 -11.38,10.71 -2.71,1.75 -5.06,1.7 -7.43,-0.12 -2.35,-1.73 -3.18,-4.43 -3.19,-7.22 0.04,-5.92 2.56,-10.62 7.33,-14.12 5.12,-3.72 10.13,-3.29 15.83,1.78 0.21,-0.51 0.44,-1.02 0.81,-1.53 5.55,-0.81 8,-3.82 11.17,-6.37 -0.02,-0.87 -0.02,-1.72 0.14,-2.73 1.29,-2.39 1.91,-4.29 2.88,-4.53 10.8,-2.48 20.03,-7.57 28.4,-14.98 2.54,-2.24 6.37,-1.64 9.76,0.08 5.18,2.65 9,6.17 9.91,12.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M809.79 1800.7c5.81,-1.81 11.05,-0.83 14.26,4.74 3.54,6.14 8.11,11.01 15.57,15.12 4.29,4.58 5.1,9.25 0.97,11.68 -6.79,4.1 -11.57,9.68 -15.64,16.22 -4.3,6.95 -11.14,9.78 -18.41,12.44 -10.21,3.75 -21.31,-5.15 -23.16,-14.59 -3.97,-20.25 7.12,-39.56 26.4,-45.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M722.68 1289.72c2.43,1.05 2.55,5.93 0.05,6.86 -6.77,2.56 -10.72,7.56 -14.78,13.39 -4.7,6.92 -12.09,11.17 -20.26,13.53 -8.32,2.4 -14.43,-2.45 -20.82,-6.18 -6.16,-3.67 -3.58,-9.68 -3.22,-16.42 0.57,-5.65 1.5,-9.66 5.38,-12.12 4.65,-2.96 9.33,-5.86 13.87,-9 11.45,-7.88 19.31,-7.81 28.42,2.26 3.44,3.81 7.03,5.86 11.37,7.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M621.18 1247.45c11.76,-0.36 21.95,-8.08 35.39,-6.91 14.34,8.11 17.14,12.93 12.2,22.49 -6.32,12.2 -16.28,20.5 -30.21,22.54 -6.21,0.92 -22.03,-7.41 -24.46,-12.72 -0.78,-1.69 -0.81,-3.96 -0.65,-5.93 0.3,-4.15 0.98,-8.22 1.46,-12.35 0.46,-3.89 2.66,-6.98 6.28,-7.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M574.65 425.05c0.41,2.66 -0.44,5.8 2.07,7.63 4.4,3.17 10.22,5.2 10.15,11.9 -0.12,8.13 8.42,8.16 11.46,13.51 5.03,8.78 0.41,19.73 -9.59,20.13 -6.64,0.24 -13.37,-1.74 -19.53,2.51 -11,-2.24 0.09,-12.71 -6.11,-17.11 -2.04,-1.4 -2.36,-5.17 -4.27,-6.93 -4.55,-4.18 -6.77,-8.21 -2.74,-14.23 1.7,-2.59 0.08,-5.61 -2.2,-7.22 -3.32,-2.42 -7.12,-4.15 -9.73,-9.4 -0.42,-2.16 -0.5,-2.92 -0.21,-3.52 3.73,-9.68 12.23,-7.66 19.26,-7.37 5.63,0.22 10.41,3.64 11.43,10.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1007.72 965.21c-1.87,2.18 -3.81,3.76 -5.75,4.62 1.01,-2.8 3.06,-4.25 5.75,-4.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1001.9 969.94c-1.07,3.17 -2.82,4.34 -5.95,4.06 -5.84,-0.54 -9.22,2.12 -9.34,8.19 -0.09,4.46 -0.94,8.73 -5.39,10.3 -6.91,2.43 -12.53,9.99 -20.76,6.91 -8.55,-3.2 -18.07,-3.8 -26.06,-10.31 -0.52,0.49 -1.04,0.97 -1.61,1.51 -7.9,3.54 -14.53,7.42 -24.56,5.94 5.72,-7.26 10.65,-13.64 10,-22.77 -0.48,-6.64 8.57,-9.82 13.49,-4.88 3.3,3.3 5.76,7.56 8.13,12.25 0.71,-0.2 1.5,-0.35 2.4,-0.44 3.88,-7.52 9.66,-12.54 10.24,-21.33 -0.17,0.15 -0.35,0.33 -0.55,0.47 -2.08,-6.41 -2.02,-6.97 2.71,-5.93 0.68,-0.51 1.47,-0.97 2.56,-1.31 4.76,-0.67 8.37,-0.27 13.03,-3.22 0.06,-0 0.12,0 0.18,-0.01 -0.49,-0.31 -0.99,-0.59 -1.45,-0.99 1.91,-6.11 4.89,-9.65 8.78,-12.45 2.87,-2.12 4.44,-4.95 6.13,-8.48 1.96,-0.11 2.63,-0.3 3.31,-0.41 5.86,-1.13 9.11,1.81 10.11,7.23 0.68,3.83 -1.74,6.47 -5.21,7.71 -5.15,1.84 -9.46,4.42 -12.25,9.86 0.75,0.63 1.47,1.37 2.19,2.25 3.71,5.26 5.9,9.69 9.12,13.1 3.35,3.49 7.11,4.29 10.84,2.63 -0.03,0.04 -0.05,0.07 -0.07,0.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1008.91 962.74c1.76,-2.63 4.31,-3.96 5.53,-0.24 0.81,2.4 -2.44,2.71 -4.44,2.6 -0.8,-0.05 -1.56,0.02 -2.29,0.12 0.17,-0.19 0.33,-0.34 0.52,-0.55 0.41,-0.47 0.32,-1.38 0.68,-1.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M896.61 540.63c2.73,3.97 5.42,7.75 8.77,11.26 3.61,3.84 0.95,10.06 -4.47,11.12 -5.31,1.06 -10.51,0.71 -15.8,3.77 -11.34,6.55 -22.3,5.62 -31.95,-6.56 -3.35,-3.53 -6.51,-5.87 -4.31,-9.87 2.31,-4.24 5.35,-8.11 7.5,-12.43 4.07,-8.21 4.01,-6.74 15.43,-7.72 10.97,-0.98 18.98,1.89 24.83,10.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1423.17 682.32c-8.16,-8.23 -6.77,-24.55 2.28,-31.71 3.78,-2.95 8.25,-5.05 14.78,-4.92 11.91,0.99 20.28,5.04 22.26,16.46 1.7,9.7 -2.45,17.57 -9.99,23.69 -10.24,8.3 -20.53,5.34 -29.33,-3.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M388.45 2260.99c5.69,3.05 8.61,10.3 6.6,18.19 -1,3.96 -2.86,7.91 -5.16,11.3 -3.51,5.17 -7.83,9.79 -13.01,15.51 -2.52,1.34 -3.76,2.22 -5.07,2.39 -11.55,1.52 -15.63,-1.44 -16.8,-12.03 -1.58,-13.77 4.19,-24.75 13.98,-33.37 5.42,-4.75 12.62,-5.64 19.45,-1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M636.75 1623.66c1.8,-9.66 9.77,-13.09 16.75,-17.37 10.87,-6.6 17.36,-5.38 25.26,3.95 5.02,5.93 5.14,12.22 0.6,19.12 -5.8,8.87 -13.85,13.51 -25.66,14.34 -7.02,1.03 -12.1,0.98 -16.18,-4.23 -4.28,-5.4 -1.8,-10.4 -0.77,-15.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M608.86 978.9c0.61,-1.95 1.63,-3.81 2.54,-5.7 2.06,-4.3 -0.04,-6.3 -3.86,-7.42 -14.42,-4.24 -14.79,-4.64 -7.06,-16.71 2.37,-3.72 3.68,-7.43 4.45,-11.44 1.35,-7.07 9.92,-7.18 12.18,-13.3 4.99,0.16 10.26,-1.6 15.07,1.89 -1.37,1.03 -2.27,2.41 -3.32,2.52 -5.1,0.54 -9.74,1.11 -8.71,8.34 0.4,2.68 -0.22,5.5 -0.24,8.25 -0.04,9.14 -0.14,18.06 10.59,22.2 3.06,1.18 4.22,5.23 4.59,9.76 0.18,0.28 0.29,0.51 0.44,0.72 4.95,4.18 8.97,2.12 12.92,2.17 8.03,0.09 9.37,1.69 10.44,11.36 0.16,1.36 -0.05,2.74 -1.47,4.38 -2.01,0.55 -2.62,0.88 -3.26,1.13 -16.29,5.96 -18.27,4.98 -21.75,-11.25 0.02,-0.06 0.13,-0.25 0.4,-0.63 0.09,-0.12 0.17,-0.21 0.27,-0.31 -0.34,0.18 -0.64,0.38 -1.09,0.61 -4.19,2 -6.03,3.06 -7.61,4.42 -3.92,3.28 -8.49,6.18 -12.89,2.53 -3.83,-3.23 -4.23,-8.53 -2.63,-13.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M746.45 398.69c-3.5,2.4 -6.89,4.72 -11.41,7.82 -20.5,5.38 -20.48,5.35 -39.88,-1.3 -1.2,-0.41 -3.13,0.44 -3.86,-0.23 -1.96,-1.9 0.33,-1.08 0.95,-1.22 10.55,-2.52 3.13,-10.49 4.8,-15.55 3.37,-10.32 4.64,-11.86 15.55,-12.87 7.32,-0.72 13.56,0.76 18.64,6.03 2.83,2.91 5.76,5.89 7.98,9.29 2.05,3.14 8.67,2.03 7.24,8.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M928.28 600.83c-3.45,1.33 -6.68,1.88 -9.47,-0.81 -7.22,-6.81 -4.8,-20.2 4.18,-23.96 3.28,-1.43 6.55,-1.94 10,-1.09 7.25,1.77 14.81,2.73 21.61,5.52 4.72,1.94 7.61,1.36 10.87,-1.85 0.48,-0.47 1.13,-0.83 1.74,-1.04 4.56,-1.58 8.27,0.53 9.15,5.18 0.76,4.03 -0.98,7 -4.62,8.09 -3.05,0.96 -7.79,-1.94 -9.54,1.28 -3.78,6.91 -10.81,13.02 -9,22.93 0.55,0.27 1.1,0.56 1.69,0.93 0.27,3.34 0.03,5.37 0.1,7.45 0.04,3.33 0.93,7.07 -3.61,8.17 -3.9,0.95 -6.32,-1.38 -8.12,-4.45 -3.17,-5.26 -3.42,-10.24 2.76,-14.34 0.07,0.02 0.09,0.03 0.13,0.05 -0.3,-0.62 -0.6,-1.32 -0.83,-2.18 -2.86,-9.86 -8.49,-13.16 -17.03,-9.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1275.94 564.97c-3.62,-0.65 -6.34,-2.27 -6.42,-6.64 -0.03,-2.76 0.2,-5.82 -0.84,-8.18 -3.4,-7.57 1,-11.85 6.24,-15.54 5.21,-3.69 11.35,-5.11 17.59,-5.42 8.94,-0.35 12.89,3.76 15.06,13.05 1.58,6.79 -0.33,12.29 -4.72,18.84 -9.34,4.88 -18.06,5.48 -26.9,3.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M697.42 1110.86c-1.05,8.19 -4.82,14.12 -12.53,17.74 -11.78,5.56 -15.63,4.81 -29.21,-8.27 -1.7,-3.74 -2.6,-6.94 -0.58,-8.92 4.97,-4.75 10.26,-9.31 15.91,-13.17 4.65,-3.12 10.37,-3.61 15.88,-2.65 6.94,1.25 11.43,8.05 10.53,15.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M588.8 1422.42c1.06,-10.63 15.51,-24.27 26.22,-25.88 4.27,-0.65 8.14,-0.28 10.95,3.45 3.61,4.68 4.23,10.67 1.21,15.41 -5.71,9.08 -12.78,16.29 -23.84,18.06 -0.07,0.08 -0.14,0.17 -0.22,0.27 0.02,0.08 0.07,0.13 0.1,0.22 -0.95,12.49 -2.86,16.06 -5.75,13.55 -4.89,-4.32 -0,-8.43 0.62,-12.65 0,-0.04 0.04,-0.09 0.04,-0.13 -0.26,-0.45 -0.52,-1 -0.73,-1.78 -7.5,-0.82 -9.12,-5.71 -8.61,-10.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M637.63 865.76c1.17,3.48 1.04,6.96 -0.74,10.04 -6.3,10.98 -26.48,12.68 -34.08,3.07 -2.86,-3.66 -3.05,-9.73 -0.66,-13.64 4.48,-7.4 14.33,-7.84 19.06,-15.13 0.54,-0.78 4.64,2.17 6.8,1.66 3.31,5.17 7.8,8.47 9.62,13.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1027.52 780.11c-9.15,3.31 -18.63,4.73 -28.22,3.45 -5.12,-0.66 -9.19,-6.26 -9.92,-11.68 -0.74,-5.55 1.88,-9.18 6.22,-12.07 6.13,-4.13 12.33,-5.95 20.38,-1.38 3.97,0.67 6.73,0.41 9.45,0.85 4.07,0.72 8.04,2.04 8.91,7.03 0.96,5.55 -1.92,12.02 -6.81,13.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1127.7 807.65c-0.41,1.92 -1.3,3.94 -2.5,5.56 -3.43,4.7 -12.25,5.6 -18.94,2.1 -5.74,-3.03 -9.35,-9.83 -7.64,-15.25 1.95,-6.04 4.82,-11.55 12.59,-14.84 5.37,-3.1 9.31,-1.91 13.26,-0.83 4.68,1.28 6.64,3.96 5.55,9.04 -1.02,4.7 -1.38,9.51 -2.32,14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1098.41 1138.72c-1.48,-1.86 0.1,-5.47 2.19,-7.53 2.75,-2.69 6.52,-3.22 9.48,-1.44 6.27,3.85 12.26,8.27 18.04,12.87 1.3,1 1.92,3.7 1.77,5.58 -0.37,5.01 -2.85,9.22 -6.44,12.67 -3.38,3.31 -7.36,3.14 -12.83,1.78 -7.61,-7.04 -6.65,-16.99 -12.21,-23.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M686.49 675.49c-1.71,4.61 -5.89,5.23 -10.2,4.88 -4.88,-0.41 -9.21,-2.25 -13.89,-6.44 -4.1,-6.91 -2.69,-11.23 2.48,-15.36 8.62,-6.91 19.8,-3.21 28.92,-7.98 0.52,-0.29 2.23,1.29 3.1,2.23 1.65,1.75 1.59,4.47 0.19,5.6 -5.53,4.54 -8.17,10.66 -10.6,17.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M752.26 1361.62c2.28,-4.61 7.95,-7.4 14.23,-5.19 6.06,2.15 11.3,3 17.7,0.73 4.43,-1.58 7.02,2.41 8.64,7.88 0.22,-0.35 0.4,-0.71 0.7,-1.08 3.66,-3.11 5.5,-6.05 7.93,-8.28 3.56,-3.13 8.5,-2.49 10.62,0.83 2.2,3.45 1.38,9.99 -2.1,10.71 -6.48,1.43 -11.79,6.84 -18.6,5.24 -0.71,0.38 -1.61,0.72 -2.75,0.92 -8.79,-0.35 -14.43,4.24 -20.68,6.97 -3.32,1.45 -6.77,1.61 -9.85,-0.36 -5.61,-3.6 -8.5,-13.06 -5.83,-18.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1525.14 2128.11c1.82,-0.75 3.96,-1.02 5.93,-0.99 4.44,0.07 7.66,2.37 10.67,7.24 3.42,5.69 3.09,10.26 1.04,14.98 -2.17,5.19 -4.38,10.75 -10.59,11.43 -6.92,0.77 -11.22,-4.14 -14.61,-9.4 -3.81,-5.97 1.07,-20.58 7.56,-23.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1020.73 354.69c-15.41,9.25 -15.98,8.98 -23.68,1.83 -4.97,-4.59 -3.64,-9.84 -3.4,-15.14 0.42,-9.41 1.94,-10.75 10.87,-10.01 14.99,1.21 18.94,6.33 16.22,23.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M917.91 787.75c4.83,1.53 9.58,10.65 8.39,15.1 -1.65,6.24 -12,13.67 -18.98,13.71 -8.54,0.02 -11.19,-3.66 -13.05,-12.3 -1.41,-6.67 5.02,-11.35 4.3,-16.92 7.46,-3.03 13.52,-1.45 19.34,0.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1368.09 1773.71c-3.46,5.16 -9.36,7.13 -16.06,5.33 -4.14,-1.13 -6.3,-5.18 -6.58,-11.41 -0.28,-6.49 1.29,-12.22 7.22,-17.71 6.61,-2.42 12.02,-4.19 16.11,1.28 4.39,5.88 5.66,12.21 1.39,18.94 -0.73,1.16 -1.3,2.43 -2.07,3.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1138.83 597.15c-6.23,0.38 -10.77,-2.9 -13.96,-10.11 -2.85,-6.45 -2.48,-10.22 2.54,-15.06 3.93,-3.82 8.46,-7.04 12.86,-10.64 2.09,3.76 4.02,6.5 8.39,8.76 4,5.22 3.94,10.17 2.86,14.95 -1.42,6.36 -7.49,11.77 -12.68,12.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M533.23 1446.96c1.94,7.38 2.28,13.38 -3.86,17.69 -5.64,3.89 -10.98,8.49 -18.57,5.44 -2.55,-1.04 -5.64,-2.03 -5.43,-5.09 0.42,-7.64 1.84,-15.14 8.56,-20.1 6.4,-4.72 12.68,-4.08 19.29,2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M146.85 667.62c-0.12,5.52 -3.01,8.78 -8.55,9.63 -8.88,1.33 -17.56,0.61 -27.45,-2.7 -5.35,-4.11 -4.85,-7.81 -0.76,-10.64 7.53,-5.32 16.25,-6.94 25.16,-7.64 1.29,-0.12 2.67,0.35 3.98,0.64 4.69,1.21 7.75,5.52 7.62,10.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M916.74 179.79c-7.9,-4.39 -12.32,-10.66 -11.59,-21.37 2.28,-4.85 5.69,-5.32 9.16,-5.76 9.45,-1.13 15.78,1.41 19.18,8.19 2.91,5.78 -0.51,10.81 -2.89,15.64 -2.89,5.87 -7.8,6.63 -13.85,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1458.71 1749.75c-0.85,0.83 -2.49,1.27 -3.76,1.29 -7.44,0.07 -17.1,-6.66 -17.4,-11.92 -0.49,-8.37 8.08,-16.77 17.59,-16.68 2.44,0.04 4.84,2.15 8.21,4.39 6.68,10.21 1.67,16.78 -4.64,22.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M272.38 539.09c-10.85,-1.56 -21.97,-3.11 -28.6,-13.57 -0.89,-1.45 -1.29,-4.31 -0.5,-5.55 0.87,-1.41 3.39,-2.29 5.26,-2.42 1.93,-0.14 3.95,0.91 7.41,1.89 8.85,0.59 16.56,-2.82 23.53,1.85 1.54,1.02 3.25,2.88 3.5,4.57 0.8,5.61 -5.73,13.98 -10.61,13.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M949.25 706.46c-0.12,-0.13 -0.22,-0.24 -0.33,-0.35 -0.06,0.54 -0.11,1.14 -0.17,1.77 -3.81,-0.1 -6.41,-0.51 -10.71,-0.79 0.26,0.19 0.53,0.34 0.75,0.53 -4.56,1.6 -8.31,2.28 -8.29,-2.17 -0.64,-0.36 -1.25,-0.78 -1.83,-1.25 0.03,-0.06 -0.02,-0.07 0.52,-0.96 -0.5,0.02 -1,0.02 -1.5,-0.02 0.99,-8.43 -6.09,-11.68 -8.37,-17.17 -1.43,-3.35 -2.29,-6.7 0.54,-9.54 2.78,-2.79 5.06,-7.06 9.87,-6.38 4.56,0.69 6.38,4.43 8.04,8.35 1.83,4.27 -2.42,9.5 1.85,13.24 5.03,0.03 9.71,-0.07 14.42,0.09 2.33,0.09 3.92,1.79 3.94,3.92 0.04,5.65 -0.43,11.19 -8.74,10.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M149.7 866.65c8.22,3.39 10.17,8.83 8.24,15.5 -1.59,5.53 -6.77,6.15 -11.43,7.24 -6.23,1.44 -12.13,0.02 -18.01,-1.71 -3.48,-0.98 -5.62,-3.58 -6.2,-7.3 -0.6,-3.99 1.98,-6.3 4.66,-8.51 6.26,-5.18 13.71,-5.59 22.74,-5.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1021.26 735.3c-4.41,-5.31 -3.67,-12.8 2.01,-18.49 1.42,-1.46 3.46,-2.3 6.49,-4.08 5.65,-1.51 9.46,-0.38 12.62,2.72 5.6,5.43 5.37,14.65 -0.33,20.63 -4.43,4.61 -16.73,4.18 -20.78,-0.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M201.26 111.01c-10.93,-1.54 -17.52,-8.14 -16.51,-14.82 0.63,-4.38 7.46,-8.68 14.84,-9 4.75,-0.21 9.46,-0.08 13.8,2.64 6.65,4.21 7.24,12.42 0.95,17.16 -3.45,2.58 -7.47,3.36 -13.08,4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M514.2 24.9c-8.34,1.01 -14.52,-2.84 -17.54,-10.74 -2.17,-5.57 0.84,-11.38 6.53,-13.2 6.41,-2.03 12.46,-0.7 17.59,2.83 4.85,3.36 6.32,8.77 3.44,15.96 -3.3,3.99 -6.65,4.84 -10.02,5.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M911.27 1753.56c-2.9,-9.13 3.09,-20.02 12.73,-22.34 4.36,-1.09 8.22,0.5 9.65,5.2 0.74,2.58 0.66,5.4 0.64,9.48 -2.61,6.7 -7.09,9.95 -11.76,12.79 -4.25,2.58 -9.66,-0.09 -11.26,-5.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1240.11 1334.7c7.01,-1.74 13.66,4.96 12.28,12.14 -0.94,4.92 -3.42,9.02 -6.23,13.02 -2.31,3.33 -0.81,6.62 -1.99,8.36 -8.93,-4.63 -15.97,-6.93 -16.12,-16.72 -0.15,-8.12 3.94,-14.78 12.07,-16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M906.1 1290.64c3.67,-0.6 8.53,1.15 8.25,4.08 -0.88,9.61 9.28,10.7 11.82,18.98 -0.36,4.19 -0.43,7.09 -1.68,9.49 -2.52,5.19 -7.29,5.74 -12.27,4.62 -3.33,-0.73 -7.99,-2.41 -7.41,-5.82 1.21,-7.15 2.48,-12.95 -7.48,-13.13 -0.74,0.02 -1.84,-1.93 -2.03,-3.08 -1.04,-7.24 3.73,-13.89 10.8,-15.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M816.28 1256.86c-1.67,-4.57 -0.1,-8.88 5.03,-12.38 2.83,-1.94 5.93,-3.73 9.16,-4.74 10.31,-3.21 17.41,3.71 15.14,14.68 -0.41,1.95 -1.97,3.63 -4.05,6.45 -5.04,1.97 -9,3.3 -13.03,3.96 -6.73,0.92 -9.87,-1.3 -12.26,-7.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M846.54 1376.44c2.88,-5.29 6.57,-6.93 10.81,-7.55 13.35,-2.02 15.34,3.93 13.04,15.75 -0.88,4.5 -4.37,6.93 -7.8,9.25 -8.74,5.95 -15.75,2.77 -16.85,-7.74 -0.26,-2.71 0.14,-5.5 0.8,-9.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1032.02 677.06c-1.23,-1.61 -2.82,-2.95 -3.82,-4.68 -0.61,-1.06 -0.88,-2.72 -0.53,-3.91 1.55,-5.29 13.75,-11.36 18.84,-8.78 5.65,2.85 12.4,4.76 15.8,11.17 -3.32,2.99 -5.88,5.28 -9.58,8.36 -13.49,7.17 -13.49,7.17 -20.7,-2.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1198.32 766.79c-3.59,-2.03 -4.36,-5.98 -2.95,-9.08 2.26,-4.99 5.75,-9.42 9.27,-15.23 0.88,-2.35 1.13,-4.55 1.69,-4.69 9.12,-1.96 11.9,0.35 10.77,8.85 -0.98,7.62 -1.51,15.47 -9.01,20.18 -3.32,2.04 -6.62,1.68 -9.78,-0.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M494.8 669.44c2.77,-1.8 6.21,-3.17 9.43,-3.51 8.04,-0.8 15.51,4.11 15.37,10.02 -0.23,8.14 -6.13,9.91 -14.08,10.31 -3.98,-0.82 -6.86,-0.94 -9.22,-2.12 -6.62,-3.31 -7.44,-10.88 -1.51,-14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1221.89 860.98c-2.5,-0.69 -4.85,-0.61 -5.05,-1.13 -2.04,-7.48 -0.56,-14.4 4.25,-20.58 3.76,-4.87 9.36,-5.7 14.24,-2.12 6.96,5.1 8.04,13.32 2.25,19.52 -3.85,4.05 -8.44,7.02 -15.69,4.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M653.38 1445.71c3.78,-1.7 6.28,-2.93 8.9,-3.28 6.75,-1.07 10.62,2.7 9.63,8.88 -0.75,4.92 -2.8,9.36 -7.14,11.83 -5.24,2.94 -10.69,6.64 -16.98,2.72 -3.99,-2.51 -3.52,-7.41 1.53,-16.45 0.61,-1.18 1.89,-1.98 4.06,-3.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M804.07 826.54c-2.41,3.05 -3.49,5.01 -5.03,6.2 -7.29,5.32 -16.4,4.49 -21.94,-1.79 -3.05,-3.44 -0.89,-8.49 6.66,-15.54 5.13,-4.84 11.2,-5 16.16,0.24 2.26,2.38 3.5,5.84 5.27,8.63 0.04,-0.17 -0.04,0.84 -1.11,2.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M247.95 1180.41c10.26,11.43 9.52,15.41 -2.24,19.62 -1.91,0.68 -3.91,1.3 -5.92,1.72 -7.22,1.48 -14.46,-0.46 -14.52,-3.98 -0.17,-6.05 3.17,-10.54 7.8,-13.9 4.03,-2.96 8.54,-4.59 14.88,-3.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M441.55 1562.48c-2.47,-0.98 -4.67,-2.78 -7.86,-5.26 -3.22,-8.68 0.07,-14.52 5.31,-19.51 3.58,-3.43 8.88,-3.45 13.15,-0.54 4.12,2.75 4.51,6.5 2.82,10.78 -1.51,3.91 -2.74,7.91 -4.59,11.58 -1.86,3.53 -5.38,4.25 -8.83,2.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1243.47 1402.1c-4.44,-7.47 -3.56,-14.44 2.64,-20.42 4.38,-4.25 10.41,-4.64 16.56,-0.56 2.23,1.44 3.95,3.73 4.95,7.15 -1.25,5.61 -1.62,9.73 -2.07,13.85 -0.36,2.91 -1.77,4.94 -4.7,5.98 -7.57,2.64 -13.33,0.71 -17.38,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M474.24 1290.88c0.42,7.79 -4.3,10.99 -8.74,13.95 -6.43,4.26 -13.56,3.6 -16.38,-0.87 -2.54,-3.97 -0.97,-9.13 4.39,-14.39 7.13,-7.03 11.45,-7.03 20.74,1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M610.16 614.93c3.23,5.19 5.58,10.44 11.22,14.1 5.8,3.73 4.78,9.17 -1.2,13.28 -2.99,2.11 -6.19,3 -10.81,0.87 -6.59,-6.77 -6.51,-16.55 -14.98,-20.62 -2.48,-1.16 -1.31,-5.11 0.41,-7.45 4.37,-5.94 11.56,-6.24 15.36,-0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1891.37 665.71c-4.55,-2.25 -6.39,-6.91 -4.75,-12.01 3.02,-9.36 8.89,-10.94 21.52,-4.52 2.61,6.18 0.8,10.54 -2.12,14.55 -3.22,4.34 -8.57,4.93 -14.65,1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M998.45 2101.98c1.27,0.16 2.82,0.68 3.63,1.6 4.5,5.21 4.88,11.01 1.04,18.28 -3.74,2.83 -6.53,4.88 -9.65,6.05 -5.32,2.14 -9.58,-0.98 -9.32,-6.53 0.11,-2.03 0.18,-4.14 0.77,-6.07 2.46,-8.49 7.9,-13.82 13.53,-13.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1115.97 1191.37c2.23,-5.11 5.05,-9.85 11.46,-10.43 5.44,-0.47 9.51,3.37 11.73,11.78 0.46,1.78 -0.6,3.97 -1.8,7.23 -3.91,4.7 -8.1,4.68 -12.13,4.79 -8.23,0.16 -12.5,-5.9 -9.26,-13.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1383.09 759.04c3.8,7.3 13.9,11.92 9.08,23.94 -3.02,2.47 -5.27,4.48 -7.83,4.93 -5.81,1.04 -12.06,-3.3 -11.97,-8.27 0.13,-6.91 1.79,-13.63 5.45,-19.62 1.11,-1.8 4.38,-2.62 5.27,-0.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M445.61 787.53c1.64,-6.9 6.15,-6.23 11.27,-4.87 8.28,2.21 11.27,4.6 11.03,9.94 -0.08,1.95 -0.76,4.15 -1.91,5.72 -3.26,4.53 -8.25,4.67 -13.12,4.27 -5.18,-0.44 -9.41,-2.27 -9.32,-9.87 0.96,-2.61 1.76,-3.87 2.05,-5.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1266.24 1122.39c-3.85,2.81 -6.68,5.09 -9.87,5.89 -5.5,1.39 -9.48,-1.25 -11.14,-6.38 -2.37,-7.36 2.52,-15.27 10.68,-17.32 5.63,-1.45 11.05,2.98 12.37,10.54 0.37,1.92 -0.72,4.04 -2.03,7.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M969.51 1048.64c-9.41,-5.08 -10.05,-14.95 -1.2,-21.09 2.11,-1.48 5.01,-1.78 8.94,-2.42 8.44,2.8 10.18,8.06 8.09,14.93 -2.03,6.58 -10.89,11.25 -15.83,8.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M994.92 1426.44c-2.11,-3.17 -1.52,-6.5 0.23,-9.59 2.69,-4.72 5.21,-9.82 13.38,-10.27 0.12,0.01 0.24,0.02 0.33,0 -0.26,-0.31 -0.56,-0.63 -0.79,-1.01 7.18,-5.22 4.47,-12.91 8.48,-18 3.73,-4.64 10.54,-4.95 13.85,0.19 3.01,4.61 2.47,9.43 -1.38,13.19 -3.54,3.42 -9.96,3.67 -12.24,9.13 0.56,0.79 1.07,1.73 1.46,2.9 1.64,10.15 -3.08,15.29 -10.92,18.11 -4.07,1.5 -9.82,-0.74 -12.41,-4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M573.72 730.75c-1.44,-4.17 1.77,-9 7.99,-9.59 5.98,-0.55 11.28,-1.55 15.58,-4.94 0.42,-0.87 0.9,-1.78 1.45,-2.73 5.09,-1.53 9.19,-2.2 14.53,-3.19l0.04 -0.03c-0.23,-0.18 -0.48,-0.29 -0.71,-0.53 3.16,-1.88 5.89,-2.75 7.56,-0.49 0.99,0.07 2.07,0.19 3.29,0.42 6.82,1.18 10.18,4.22 11.3,9.5 0.71,3.39 0.78,6.82 -0.86,10.13 -3.96,8.03 -11.63,11.01 -20.84,7.43 -3.1,-1.19 -5.71,-3.66 -9.99,-6.07 -0.1,-0.04 -0.16,-0.08 -0.23,-0.14 0.01,0.2 0.08,0.36 0.09,0.55 -8.45,-1.87 -9.74,6.1 -14.94,7.7 -5.71,1.7 -11.97,-1.34 -14.26,-8.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1035.53 982.87c6.42,9.18 1.02,22.06 -9.94,23.62 -4.4,0.65 -7.75,-2.01 -11.49,-5.3 -1.73,-6.57 -2.03,-11.16 0.49,-15.81 3.74,-6.98 16.72,-8.57 20.93,-2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M315.48 169.6c-3.91,-3.61 -7.64,-7.58 -9.17,-13.04 -0.73,-2.53 0.96,-4.01 2.95,-4.1 3.32,-0.14 6.65,0.35 11.4,0.81 2.69,0.55 4.18,0.6 5.28,1.28 6.62,4.35 8.13,8.15 5.26,12.89 -3.29,5.45 -10.78,6.69 -15.72,2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M757.11 277.65c1.26,2.74 0.34,5.32 -1.97,7.38 -2.7,2.44 -5.93,3.36 -10.83,3.25 -3.62,-2.87 -6.24,-5.18 -7.94,-8.03 -2.97,-5.2 -2.96,-11.79 -0.31,-13.43 4.82,-2.96 9.29,-0.25 13.57,1.42 4.01,1.57 5.8,5.68 7.47,9.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M632.38 985.78l0.02 0.03 -0.03 0.05c0.01,-0.01 0.01,-0.05 0.02,-0.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M632.36 985.86c0.01,0.03 -0.02,0.05 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1101.1 904.7c5.48,3.62 7.44,7.73 7.55,12.86 0.12,4.78 -2.13,7.65 -6.99,8.27 -2.65,0.31 -5.38,0.6 -8.04,0.3 -4.29,-0.49 -7.65,-2.61 -8.82,-7.16 -1.29,-4.96 -0.73,-9.64 3.5,-13.02 3.35,-2.7 7.27,-3.57 12.79,-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M116.38 559.81c-4.48,-2.85 -5.33,-8.61 -2.08,-12.21 4.11,-4.59 9.34,-5.24 14.76,-4.59 4.47,0.54 6.89,3.72 7.57,9.46 -8.72,10.42 -13.26,11.75 -20.25,7.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1761.94 2283.23c-1.58,-0.18 -3.69,-2.03 -4.36,-3.65 -2.12,-4.96 -3.96,-10.15 -5.29,-15.39 -1.03,-4.2 -0.07,-8.45 4.3,-10.48 5.36,-2.53 9.14,-0.52 11.51,6.38 2.08,7.01 -1.2,12.09 -1.65,17.54 -0.22,2.68 -1,5.89 -4.51,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M716.93 1020.84c-7.41,-1.76 -9.33,-7.96 -4.75,-13.66 2.28,-2.81 5.11,-4.3 8.39,-5.33 5.75,-1.76 8.47,0.11 12.19,7.19 3.37,6.48 -1.07,8.36 -6.61,11.18 -3.95,0.64 -6.74,1.24 -9.22,0.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M632.55 443.03c-7.23,-0.36 -12.65,-1.57 -13.22,-8.79 -0.47,-6.09 3.77,-11.74 8.95,-12.47 5.78,-0.82 13.5,3.65 14.75,8.98 0.41,1.85 -0.27,4.18 -1.01,6.01 -1.44,3.53 -4.73,4.94 -9.47,6.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M470.46 732.12c0.08,4.63 -2.37,8.02 -6.54,9.57 -8.25,3.08 -13.22,1 -20.04,-9.25 4.97,-7.64 11.41,-9.16 18.62,-8.53 4.02,0.37 7.91,4.36 7.95,8.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1087.07 744.96c0.77,-4.91 6.3,-7.97 10.81,-7.08 4.01,0.83 8.38,6.05 8.09,10.34 -0.3,4.43 -2.7,7.42 -7.01,9.09 -4.16,1.63 -7.87,0.71 -11.73,-0.55 -0.6,-0.2 -1.09,-0.22 -1.51,-0.14 1.06,-4.01 0.72,-7.92 1.35,-11.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1085.72 756.62c-0.24,0.85 -0.52,1.75 -0.91,2.62 -0.81,-1.05 -0.42,-2.4 0.91,-2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1130.98 667.66c3.66,2.68 4.87,6.58 3.8,10.91 -1.34,5.32 -5.35,7.85 -10.46,8.48 -5.1,0.64 -6.92,-3.3 -9.32,-8.2 -1.1,-4.07 -0.71,-6.94 1.22,-8.97 4.39,-4.49 10.49,-5.34 14.75,-2.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1101.67 347.95c-2.32,-1.05 -4.07,-3.34 -6.41,-6.51 0.55,-4.75 1.04,-8.2 2.45,-11.26 0.72,-1.57 2.92,-3.22 4.68,-3.52 5.24,-0.89 9.16,2.09 12.4,5.7 2.22,2.5 1.02,9.65 -2.01,13.53 -3.08,3.87 -7.21,3.82 -11.11,2.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M720.57 536.53c1.78,6.17 -3.06,6.56 -8.88,6.44 -7.28,0.01 -8.82,4.8 -11.23,9.29 -1.83,-4.78 -3.59,-9.18 -5.2,-13.61 -1.05,-2.84 -0.46,-5.6 1.66,-7.7 8.75,-8.78 20.27,-6.27 23.67,5.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M629.61 184.07c-5.5,-3.54 -8.12,-13.39 -5.65,-18.47 1.37,-2.82 4.16,-3.76 7.06,-2.89 7.06,2.15 12.17,6.21 12.44,15.61 -3.31,7.37 -8.27,9.31 -13.85,5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1024.11 1223.45c1.72,5.03 -2.38,11.11 -9.44,13.96 -6.58,2.69 -11.64,-1.45 -11.1,-9.3 0.13,-1.98 1.26,-3.94 2.77,-6.97 11.56,-4.6 15.7,-3.73 17.77,2.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M343.95 1893.64c7.19,0.01 8.83,5.31 8.01,13 -3.38,7.31 -8.56,8.8 -14.36,8.07 -3.58,-0.46 -6.42,-2.83 -6.36,-6.94 0.1,-7.1 6.12,-14.16 12.71,-14.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M984.64 805.22c-3.97,3.88 -5.6,7.98 -4.99,12.83 0.8,0.64 1.61,1.52 2.42,2.82 3,6.03 5.27,10.9 6.96,16.01 6.17,18.66 3.33,16.55 -11.27,23.87 -3.82,1.91 -8.82,3.57 -14.81,1.25 -0.12,-0.04 -0.23,-0.05 -0.34,-0.09 -0.03,0.21 -0.01,0.38 -0.06,0.6 -5.9,0.32 -10.02,0.61 -11.39,5.88 -0.87,3.31 -1.15,6.86 -2.6,9.86 -1.51,3.17 -8.37,3.1 -11.04,0.37 -2.46,-2.53 -1.3,-4.98 -0.03,-7.55 3.39,-7 10.91,-9.28 17.22,-14.21 -0.28,-0.54 -0.56,-1.13 -0.8,-1.8 -0.32,-2.69 -0.29,-4.23 -0.23,-7.65 -0.05,-0.33 -0.06,-0.64 -0.09,-0.94 -0.34,0.58 -0.69,1.12 -1.09,1.67 -2.95,-6.61 -5.96,-9.5 -12.28,-10.8 -7.68,-1.51 -8.71,-7.36 -4.02,-13.77 3.59,-4.91 7.36,-5.5 11.79,-1.61 1.46,1.3 3.01,2.79 3.76,4.57 1.77,4.12 4.24,4.35 6.66,4.06 1.54,-1.16 3.48,-2.08 5.92,-2.8 2.22,-2.98 3.82,-4.89 6.21,-8.03 0.03,-0.02 0.07,-0.04 0.09,-0.06 -0.28,-0.08 -0.56,-0.11 -0.83,-0.2 4.92,-7.03 -0.53,-11.58 -1.12,-16.61 -0.53,-4.52 2.08,-8.19 5.93,-9.9 3.97,-1.75 8.06,-0.75 10.82,2.92 2.34,3.11 1.79,6.81 -0.81,9.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M812.01 455.16c-3.94,-4.17 -6.43,-9.75 -9.23,-14.91 -0.47,-0.85 0.13,-2.69 0.71,-3.79 2.21,-4.01 5.89,-6.13 10.1,-5.07 4.25,1.02 6.8,4.43 5.81,9.22 -0.54,2.58 -2,5.04 -3.12,8.9 0.1,4.62 -2.4,7.68 -4.29,5.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M402.54 1210.88c-1.45,-1.57 -1.95,-2.75 -2.49,-5.58 -0.25,0.4 -0.48,0.77 -0.77,1.12 -4.19,-5.24 -1.95,-7.84 1.81,-8.39 0.44,-1.09 0.96,-2.19 1.62,-3.44 4.95,-9.59 11.42,-12.63 21.41,-8.87 0.03,0.02 0.05,0.04 0.09,0.06 -0.11,-0.23 -0.24,-0.45 -0.29,-0.67 4.13,0.29 6.26,1.83 5.08,4.93 0.41,0.75 0.8,1.54 1.19,2.48 0.8,4.59 1.9,8.03 -1.96,11.98 -0.07,0.01 -0.14,0.01 -0.21,0.03 0.31,0.1 0.61,0.16 0.9,0.29 -5.46,7.51 -13.08,8.72 -19.95,11.07 -2.52,0.81 -4.77,-1.05 -4.41,-4.24 -0.66,-0.19 -1.33,-0.43 -2.03,-0.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M184.64 1752.01c-0.52,-5.21 1.68,-9.61 6.54,-11.77 3.8,-1.72 8.19,-2.4 11.45,0.88 3.44,3.45 1.91,7.59 0.08,11.41 -0.56,1.2 -1.7,2.11 -3.76,3.68 -4.52,1.66 -7.99,2.16 -11.03,0.39 -1.54,-0.88 -3.09,-2.93 -3.28,-4.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M846.23 618.17c0.8,0.71 1.61,1.52 2.4,2.59 6.3,5.18 7.5,10.36 4.48,17.68 0.41,-0.13 0.81,-0.27 1.24,-0.41 5.68,1.84 11.7,1.97 10.39,8.97 -0.79,4.05 -0.29,6.5 3.8,7.76 2.6,0.81 4.97,2.02 6.01,4.98 0.77,2.12 -0.98,6.24 -3.07,6.84 -5.87,1.65 -10.64,-1.37 -15.46,-3.65 -3.63,-1.65 -3.85,-5.3 -3.43,-8.87 0.66,-5.4 -2.72,-7.65 -5.72,-10.43 -1.07,0.12 -2.32,0.03 -3.78,-0.28 -17.25,-2.76 -19.13,-5.67 -14.11,-19.8 0.42,-1.17 1.33,-2.21 2.9,-4.12 -0.62,-0.07 -1.21,-0.11 -1.85,-0.19 -3.13,-3.62 -5.67,-6.15 -6.99,-9.19 -2.91,-7.01 0.77,-12.14 8.38,-12.61 5.43,-0.3 9.22,1.85 11.77,6.52 2.43,4.42 3.43,9.25 3.05,14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M273.57 782.7c-1.22,3.91 -4.55,4.85 -8.04,5.42 -6.75,1.06 -7.89,0.16 -12.36,-10.9 3.06,-3.33 5.7,-5.58 8.62,-7.21 3.26,-1.8 6.74,-1.61 9.47,1.12 3.17,3.22 3.69,7.29 2.31,11.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M957.7 493.86c-2.41,4.15 -4.35,7.38 -8.4,6.94 -4.04,-0.44 -8.29,-1.17 -10.86,-4.88 -2.13,-3.11 -2.07,-6.7 0.4,-9.62 3.57,-4.27 8.38,-4.26 13.23,-2.98 4.73,1.26 6.54,4.51 5.63,10.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1193.11 813.95c-2.14,3.08 -5.52,3.91 -8.9,3.78 -3.87,-0.16 -6.21,-3 -6.4,-6.54 -0.24,-3.98 0.68,-7.99 0.89,-13.32 -0.55,-3.67 1.38,-6.18 2.59,-5.23 4.64,3.47 9.09,7.42 12.82,11.87 2.32,2.77 1.07,6.51 -1.01,9.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M881.01 1899.37c4.78,1.97 4.72,6.21 3.67,10.43 -0.81,3.32 -2.02,6.55 -6.15,9.29 -6.04,1.68 -9.08,-0.25 -10.4,-4.92 -1.16,-4.06 -1.51,-8.06 1.96,-11.46 3.15,-2.99 6.64,-5.08 10.92,-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M598.28 1463.86c1.79,1.8 3.55,4.42 3.84,6.87 0.57,4.34 -1.52,8.08 -5.63,10.17 -5.45,2.77 -10.53,3.36 -14.18,-4.31 0.89,-6.49 4.42,-9.84 8.42,-12.66 2.41,-1.71 5.4,-2.18 7.54,-0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1827.39 731.29c-6.13,1.17 -8.15,-3.69 -10.1,-8.18 -0.3,-0.61 -0.45,-1.32 -0.77,-3.3 1.57,-7.77 5.24,-10.88 12,-8.94 4.62,1.35 6.59,4.76 6.68,9.28 0.06,4.64 -3.76,10.38 -7.81,11.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M747.11 178.11c-3.18,-1.13 -5.89,-3.42 -9.65,-6.17 -1.47,-9.52 0.24,-12.66 5.63,-12.6 5.07,0.03 9.64,1.28 12.57,5.78 2.06,3.09 2.4,6.53 0.46,9.83 -2.08,3.55 -5.65,4.34 -9,3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1273.87 287.97c-6.85,-2.26 -8.33,-5.99 -6.38,-14.46 0.82,-3.59 2.3,-6.6 6.37,-6.6 6.53,-0.03 10.81,4.3 11.15,11.43 0.08,1.89 -1.2,3.84 -2.76,6.81 -3.06,3.06 -5.75,3.69 -8.38,2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M571.72 1631.16c1.82,-0.26 4.24,0.22 5.63,1.32 2.42,1.91 1.74,4.96 0.72,7.46 -2.81,6.79 -8.17,10.85 -13.77,9.52 -4.98,-1.21 -8.09,-4.61 -6.01,-11.8 3.97,-5.36 8.81,-5.81 13.43,-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1676.67 1336.6c3.72,-1.71 3.13,-5.65 4.51,-8.58 3.56,-7.45 6.85,-8.13 14.41,-2.94 1.05,0.71 1.58,2.21 2.69,4.86 -5.21,13.45 -6.5,14.16 -15.38,9.94 -2.1,-1.01 -4.15,-2.17 -6.23,-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1156.28 1089.33c-3.07,-5.54 -1.62,-9.1 1.51,-12.24 2.47,-2.47 5.22,-4.19 8.88,-4.29 5.05,-0.15 8.95,3.64 8.84,8.87 -0.33,10.33 -6.88,13.5 -19.23,7.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1276.05 1470.11c2.6,0.77 5.49,1.04 7.89,2.24 1.58,0.79 3.54,2.81 3.53,4.32 0,1.46 -2.76,4.49 -3.46,4.23 -7.59,-2.52 -12.8,4.66 -20.75,3.85 -1.59,-15.48 1.15,-18.13 12.79,-14.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1219.7 1220.41c-1.88,4.22 -5.43,6.71 -9.81,6.38 -5.05,-0.37 -6.06,-4.9 -6.71,-9.11 -0.19,-1.33 0.32,-2.75 0.84,-5.43 3.02,-6.71 7.15,-8.17 12.13,-4.83 4.3,2.9 5.56,8.32 3.54,12.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M845.65 913.96c-1.4,-2.01 -4.05,-4.01 -2.85,-7.49 5.25,-2.77 10.75,-4.92 18.22,-3.18 -0.17,-0.52 -0.34,-1.09 -0.49,-1.7 5.59,-21.36 8.14,-23.41 28.07,-24.05 1.35,-0.03 2.69,0.03 5.37,0.9 9.54,8.82 9.94,17.65 3.45,26.92 -2.87,4.11 -7.29,6.26 -12.07,7.63 -4.96,1.45 -9.36,0.53 -14.76,-2.8 0.03,0.27 0.09,0.5 0.09,0.78 -4.03,2.62 -6.79,4.79 -9.69,6.6 -7.3,4.42 -10.21,3.87 -15.34,-3.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M842.14 489.54c-0.53,4.31 -5.76,6.7 -13.46,5.72 -1.87,-0.24 -3.59,-1.72 -6.23,-3.79 -2.76,-4.54 -2.41,-7.55 0.54,-10.28 2.08,-1.93 4.3,-3.37 7.2,-3.18 6.51,0.44 12.55,6.32 11.95,11.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M311.24 1449.24c2.49,-0.77 5.46,-0.77 7.97,-0.18 2.79,0.69 4.22,3.21 4.1,7.65 -3.63,8.91 -9.31,11.38 -17.01,9.47 -3.15,-0.77 -4.59,-3.22 -3.82,-6.15 1.26,-4.8 3.77,-9.16 8.76,-10.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1293.24 595.78c-5.36,-0.51 -10.7,-1.39 -12.82,-8.43 3.46,-5.32 7.41,-7.57 12.57,-7.64 5.45,-0.01 9.55,4.11 8.82,8.89 -0.61,4.1 -4.43,7.58 -8.58,7.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M900.5 2143.94c0.63,-3.21 2.83,-6.12 5.17,-10.22 7.8,-2.8 10.87,-1.7 11.35,2.61 0.55,4.18 0.11,8.24 -2.03,11.89 -1.74,3.01 -4.18,5.75 -8.12,4.65 -4.27,-1.26 -7.27,-4.22 -6.37,-8.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1083.05 760.25c-0.1,-0.05 -0.2,-0.11 -0.29,-0.17 0.08,-0.08 0.22,0.12 0.29,0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1082.76 761.1c0.93,6.09 -0.22,9.97 -4.19,12.46 -5.85,3.69 -12.77,1.13 -15.09,-5.35 -1.62,-4.55 1.11,-8.85 6.58,-11.33 5.45,-2.48 8.92,0.94 12.69,3.21 -0.04,0.07 -0.07,0.29 0.01,1.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1042.72 1354.44c-2.36,-4.23 -2.96,-9.05 -0.52,-13.55 2.16,-3.97 5.68,-5.6 11.4,-4.15 5.63,3.6 7.99,7.81 5.39,12.69 -2.16,4.16 -5.89,7.71 -11.23,7.41 -1.77,-0.09 -4.27,-1 -5.04,-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M589.57 1285.47c0.8,2.91 -0.59,5.37 -3.33,8.74 -3.78,4.14 -6.4,7.4 -9.35,10.25 -1.69,1.71 -3.89,0.95 -5.56,-0.29 -0.99,-0.75 -2.39,-2.4 -2.15,-3.2 2.26,-7.83 4.75,-15.72 12.61,-19.95 3.03,-1.63 6.73,0.53 7.79,4.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M916.44 534.77c-3.74,1.2 -6.45,-0.56 -8.99,-2.99 -2.49,-2.45 -4.09,-5.31 -3.47,-10.12 5,-6.29 10.31,-5.03 15.4,-3.02 1.47,0.58 2.93,2.82 3.19,4.52 0.87,4.9 -2.33,10.41 -6.13,11.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M380.5 912.95c3.06,-0.1 3.68,3.53 2.95,7.8 -9.15,7.59 -17.99,2.73 -26.62,2.62 -2.09,-0.04 -4.04,-1.67 -3.57,-3.97 0.36,-1.77 1.64,-4.11 3.15,-4.82 7.77,-3.61 16.05,-1.38 24.1,-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1640.5 1417.04c-5.6,-0.42 -7.76,-4.71 -9.25,-9.37 -1.15,-3.65 0.1,-6.62 3.13,-8.87 4.41,-3.27 8.6,-3.62 12.87,2.36 1.72,4.4 2.75,7.71 1.32,11.07 -1.44,3.56 -4.48,5.08 -8.08,4.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M643.83 507.79c-1.61,4.25 -4.85,6.55 -9.45,5.64 -4.31,-0.87 -9.89,0.29 -11.32,-5.98 -0.26,-1.2 -0.03,-2.79 0.5,-3.91 1.54,-3.15 4.06,-5.31 9.02,-5.73 3.21,0.78 5.19,1.28 6.89,2.19 2.97,1.62 5.97,3.68 4.37,7.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M472.65 666.9c-2.06,1.58 -4.91,2.11 -8.9,3.44 -6.97,0.51 -14.15,7.65 -17.31,-0.94 -2.31,-6.22 6.11,-8.05 9.72,-11.63 4.58,-4.59 11.1,-3.82 16.51,0.27 2.45,1.85 2.75,6.77 -0.01,8.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1437.6 591.17c0.87,5.3 -0.66,9.5 -8.15,10.05 -4.79,-0.62 -7.57,-2.28 -8.45,-6.02 -1.25,-5.39 1.39,-9.94 6.2,-11.04 4.81,-1.07 9.57,1.82 10.39,7.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M983.66 754.96c0.52,5.25 -3.72,6.55 -7.5,8.06 -3.22,1.32 -6.54,2.05 -9.55,-0.24 -3.03,-2.31 -3.68,-5.46 -1.95,-10.25 2.76,-2.68 4.82,-4.98 7.19,-5.48 5.89,-1.24 11.21,2.42 11.8,7.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M193.2 832.57c-2.48,-1.36 -3.33,-4.29 -1.33,-6.96 2.06,-2.72 4.17,-5.45 6.72,-7.62 4.72,-4.01 10.9,-1.48 11.95,4.95 0.88,5.34 1.2,10.76 0.1,17.03 -8.18,0.61 -12.23,-4.57 -17.45,-7.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M433.44 2249.18c7.34,1.44 7.75,5.87 5.58,10.87 -1.98,4.61 -5.12,8.17 -10.71,7.65 -3.24,-0.35 -4.26,-3.02 -4.55,-5.82 -0.66,-6.45 3.23,-9.92 9.67,-12.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M604.94 333.51c-3.4,-1.38 -5.35,-3.91 -5.53,-9.25 1.35,-3.27 2.21,-5.28 3.7,-6.6 4.01,-3.53 8.44,-4.33 12.79,-0.71 4.44,3.69 5.2,10.08 1.92,14.68 -2.53,3.55 -7.04,4.22 -12.89,1.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M159.41 401.58c-3.66,-1.67 -7.51,-3.53 -9.07,-7.68 -0.36,-0.94 0.26,-3.05 1.06,-3.59 4.78,-2.97 10.08,-4.26 15.5,-2.65 3.62,1.1 4.79,4.56 5.51,9.51 -3.76,5.76 -8.2,6.62 -13,4.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1676.38 1189.89c-0.76,-1.01 -0.81,-2.55 -1.09,-5.1 0.41,-1.9 0.62,-2.7 1.1,-3.07 6.35,-4.1 11.2,-4.28 13.87,-0.52 2.57,3.66 2.17,10.16 -0.88,13.21 -3.27,3.33 -8.22,1.71 -13,-4.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1244.8 766.09c-2.3,2.95 -5.38,4.06 -10.33,2.58 -2.55,-2.25 -4.46,-3.63 -4.94,-5.43 -1.6,-5.61 0.31,-10.53 4.5,-12.11 4.05,-1.55 8.09,-1.11 11.35,1.96 3.34,3.11 3.05,8.37 -0.59,13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M975.82 427.17c1.06,3.41 1.06,7.19 -1.87,9.51 -3.71,2.98 -7.71,1.27 -11.29,-0.82 -3.23,-1.88 -4.55,-4.87 -3.97,-9.8 2.98,-2.42 5.27,-4.15 7.8,-4.65 4.55,-0.89 7.9,1.29 9.33,5.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M471.07 1006.78c-1.66,1.17 -3.49,2.21 -5.39,2.97 -3.85,1.59 -8.15,-0.26 -10.34,-4.22 -2.08,-3.71 -1.12,-8.27 3.01,-10.6 2.92,-1.63 6.4,-2.25 10.98,-3.02 7.69,8.09 7.8,10.65 1.74,14.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M344.19 1754.87c0.39,-4.09 3.59,-5.6 7.03,-6.35 2.93,-0.64 5.18,0.93 7.71,4.27 0.74,3.2 1.31,5.37 0.77,7.2 -1.06,3.64 -3.93,5.65 -7.75,5.3 -4.39,-0.37 -8.25,-5.55 -7.77,-10.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M394.29 554.64c4.12,-1.84 8.04,-1.56 10.59,2.5 2.44,3.89 0.97,9.58 -3.14,12.69 -1.6,1.22 -3.56,2.01 -5.46,2.64 -4.13,1.36 -8.02,-0.78 -8.91,-5.61 -0.38,-2.36 1.11,-5.1 2.67,-8.82 2.07,-1.9 3.1,-2.86 4.25,-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M498.37 585.83c-2.52,-0.14 -4.97,-1.5 -8.26,-3.39 -3.02,-5.76 -0.58,-8.74 2.95,-11.36 2.3,-1.66 4.85,-2.79 7.4,-1.15 3.55,2.28 6.2,5.62 5.24,10.09 -0.75,3.48 -3.52,6.09 -7.33,5.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M422.19 1147.26c4.12,3.52 4.77,7.09 1.73,9.69 -4.1,3.55 -8.83,6.5 -13.6,9.14 -1.29,0.73 -3.82,-0.26 -5.42,-1.14 -0.66,-0.4 -1.05,-2.73 -0.55,-3.71 2.16,-4.29 4.45,-8.54 7.19,-12.49 2.29,-3.29 5.91,-2.94 10.64,-1.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1482.45 1407.12c2.52,-1.18 5.39,-1.97 7.79,-0.19 3.08,2.32 3.43,6.04 2.75,9.41 -0.71,3.68 -3.72,5.67 -8.47,6.97 -4.88,-1.23 -6.35,-4.18 -6.74,-7.85 -0.48,-3.84 1.22,-6.75 4.66,-8.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1168.85 761.38c-1.71,-3.54 -1.14,-6.61 2.31,-8.65 3.24,-1.93 6.71,-1.55 9.29,1 2.57,2.57 2.89,6 0.7,9.25 -2.26,3.36 -4.53,6.72 -7.07,9.87 -0.65,0.77 -2.36,0.71 -3.55,1.06 -0.26,-1.3 -0.67,-2.57 -0.73,-3.87 -0.02,-1.32 0.29,-2.68 0.16,-5.39 -0.61,-2.01 -0.84,-2.65 -1.11,-3.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M754.62 560.63c6.36,-1.3 11.85,1.77 17.93,4.61 0.3,-0.5 0.65,-1.03 1.07,-1.55 5.77,-0.86 9.36,0.6 8.05,5.95 -0.95,3.8 -4.49,4.46 -8.03,2.95 -1.05,-0.44 -1.95,-1.1 -2.62,-2.34 -0.49,0.51 -1.05,1.03 -1.77,1.63 -6.45,5.54 -12.16,6.15 -17.98,2.15 -2.32,-1.64 -4.19,-4.09 -3.79,-6.91 0.54,-3.83 3.51,-5.76 7.15,-6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M617.72 404.94c2.42,7.55 -1.51,9.82 -6.56,10.63 -4.81,0.75 -9.65,-0.01 -12.01,-4.93 -1.61,-3.31 -0.03,-6.57 3.18,-8.57 5.27,-3.37 10.1,-2.31 15.38,2.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1313.85 1715.35c-2.2,2.79 -4.99,4.98 -8.56,3.88 -3.58,-1.1 -4.47,-4.67 -5.03,-9.4 0.7,-2.58 1.07,-4.07 1.99,-4.84 5.16,-4.28 9.25,-4.51 11.98,-0.76 2.75,3.7 2.46,7.52 -0.38,11.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M921.64 384.27c-1.34,-1.26 -2.91,-3.53 -2.69,-5.09 0.62,-4.22 3.54,-7.24 7.3,-9.24 3.46,-1.81 6.45,-1.16 9.25,3.29 1.56,5.41 2,9.46 -2.58,11.95 -3.9,2.07 -7.91,2.13 -11.28,-0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M876.55 317.51c1.93,-1.97 3.04,-3.25 4.23,-3.38 7.11,-0.81 10.91,2.18 11.14,8.41 0.15,5.02 -3.53,8.63 -9.3,9.18 -3.02,0.3 -5.5,-0.75 -7.2,-3.1 -2.34,-3.27 -0.89,-6.64 1.13,-11.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1960.29 985.48c-3.9,-1.54 -6.24,-6.02 -5.03,-10.08 1.03,-3.34 2.91,-6.39 6.68,-7.14 4.1,-0.78 5.84,2.53 8.35,6.58 -0.15,3.34 -0.27,5.62 -1.31,7.2 -2.04,2.99 -4.88,4.95 -8.7,3.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M174.63 606.91c1.67,4.28 0.76,6.55 -2.14,7.85 -3.32,1.49 -6.67,1.12 -9.98,0.2 -7.09,-2.02 -12.21,-7.58 -9.85,-10.65 3.31,-4.26 7.53,-1.44 11.26,-1.18 3.3,0.2 6.5,1.66 10.71,3.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M988.08 540.93c-6.45,-1.59 -10.16,-4.36 -6.81,-10.41 2.67,-4.74 7.5,-5.55 12.38,-2.39 1.49,0.97 2.98,3.12 3.14,4.83 0.46,5.11 -3.1,7.09 -8.7,7.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1224.53 1125.75c-1.8,0.09 -4.18,-0.55 -5.38,-1.76 -2.87,-2.85 -2.82,-11.11 0.31,-15.08 2.9,-3.69 6.9,-3.63 11.78,-0.18 2.65,4.06 4.36,7.1 2.78,10.58 -1.83,4.01 -5.26,6.2 -9.5,6.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1385.32 1324.17c-2.88,-0.49 -4.55,-2.8 -6.13,-6.58 -0.02,-4.17 1.62,-6.29 3.76,-8.18 3,-2.6 6.21,-3.13 9.3,-0.75 3.09,2.35 3.53,5.9 2.45,9.38 -1.43,4.45 -4.58,6.94 -9.38,6.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M704.53 1332.76c5.11,0.44 7.68,2.6 7.9,6.54 0.23,4.83 -2.85,7.59 -7.01,9.28 -3.48,1.44 -7.17,1.45 -9.61,-1.3 -2.59,-2.9 -1.67,-6.75 0.76,-9.5 1.76,-2.01 4.39,-3.27 7.96,-5.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M822.83 1435.24c2.01,-1.7 4.42,-3.29 6.91,-4.05 1.68,-0.52 4.31,-0.17 5.54,0.95 1.17,1.06 1.91,3.93 1.25,5.29 -1.4,3.01 -3.74,5.53 -6.94,8.95 -4.73,1.45 -7.96,1.33 -9.82,-2.39 -1.91,-3.86 0.42,-6.56 3.05,-8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1007.8 1020.97c-2.04,2 -4.48,3.48 -7.12,2.76 -1.59,-0.44 -3.15,-2.4 -3.86,-4.08 -1.16,-2.69 -0.17,-5.68 2.08,-7.25 4.85,-3.41 9.99,-6.29 14.95,-9.2 -0.09,0.16 0.22,-0.1 -0.9,1.17 -2.64,6.33 -0.72,12.27 -5.14,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1632.14 549.28c-3.87,-3.7 -2.78,-8.12 3.38,-13.24 0.46,-0.43 1.27,-0.43 3.19,-0.73 7.56,5.74 8.28,8.59 4.36,12.84 -3.26,3.51 -7.93,4.01 -10.93,1.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1619.58 878.29c-3.39,4.88 -8.62,5.98 -12.18,2.69 -3.65,-3.42 -3.84,-8.86 -0.03,-12.82 3.42,-3.56 7.15,-3.46 11.56,1 1.64,3.87 2.44,6.59 0.65,9.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M152.07 1857.61c6.24,-0.36 7.88,3.65 5.83,10.44 -3.98,3.54 -7.7,5.31 -11.75,4.19 -1.58,-0.39 -3.62,-2.3 -3.8,-3.79 -0.61,-4.96 4.14,-10.49 9.71,-10.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M719.51 1053.79c-1.51,3.03 -6.15,1.44 -8.37,-1.63 -1.89,-2.6 -0.84,-5.18 0.93,-7.45 2.43,-3.12 5.53,-3.57 10.27,-1.84 4.5,0.96 7.74,1.31 12.89,1.9 -5.6,4.4 -12.61,2.77 -15.72,9.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M539.08 1824.04c2.09,-6.11 4.4,-10.43 9.63,-11.71 1.75,-0.45 4.23,0.06 5.63,1.12 2.22,1.69 3.13,4.52 1.61,7.33 -2.65,5.03 -6.15,9.54 -11.86,10.8 -4.46,1.02 -5.86,-2.05 -5.02,-7.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M297.09 972.35c-0.81,-4.93 -0.98,-9.02 -0.21,-12.92 0.9,-4.52 5.14,-6.45 9.16,-4.72 4.03,1.7 6.02,6.14 4.06,9.86 -2.52,4.8 -5.42,9.46 -13.01,7.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M572.72 974.93c0.57,-0.06 1.12,-0.13 1.73,-0.16 4.03,4.45 4.04,8.1 0.56,11.52 -2.61,2.58 -6.02,3.54 -9.26,2.26 -4.3,-1.71 -4.37,-5.38 -2.96,-9.74 -0.58,-0.05 -1.11,-0.02 -1.75,-0.14 -4.58,1.18 -8.9,2.79 -9.66,-1.94 -0.96,-6.18 3.35,-12.39 7.81,-12.64 4.02,-0.17 8.21,-0.2 11.71,2.48 2.45,1.87 2.44,4.61 1.83,8.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1103.55 1036.87c-0.89,1.58 -1.63,1.84 -3.23,-0.89 -1.39,-5.09 -2.96,-8.93 -3.55,-12.88 -0.22,-1.32 1.85,-3.6 3.39,-4.43 3.39,-1.83 6.81,-0.94 8.94,2.2 0.99,1.43 1.57,4.13 0.89,5.56 -1.76,3.68 -4.38,6.91 -6.45,10.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1201.34 642.38c-1.56,-5.11 -2.93,-10.32 -4.38,-15.46 5.32,-3.23 10.19,-5.84 16.01,0.38 2.61,7.66 -1.32,11.82 -5.03,16.02 -2.01,2.33 -5.73,1.83 -6.61,-0.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1083.77 964.94c1,-5.67 4.86,-8.57 9.96,-7.43 4.34,0.98 5.08,3.77 3.08,11.57 -0.16,0.64 -0.75,1.12 -2.07,2.52 -9.47,0.69 -11.94,-1.17 -10.96,-6.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M415.62 849.81c-3.89,-2.5 -4.23,-7.79 -0.88,-10.27 2.05,-1.55 4.64,-2.92 7.14,-3.3 7.43,-1.14 11.2,3.9 8.57,11.33 -0.6,1.7 -2.72,2.85 -5.7,4.44 -4.12,-0.58 -7.01,-0.8 -9.13,-2.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1018.52 682.37c2.57,1.47 2.49,4.6 2.62,7.23 0.23,6.55 -1.68,9.56 -6.77,10.64 -5.77,1.21 -8.73,-1.63 -9.02,-8.74 2.34,-3.42 4.08,-5.51 6.07,-7.29 1.98,-1.79 4.53,-3.29 7.1,-1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M978.86 2268.71c3.65,3.39 2.47,7.79 -2.59,12.43 -5.35,4.92 -8.41,3.44 -10.44,-5.17 -0.12,-0.62 0.22,-1.34 0.77,-3.24 3.6,-5.88 7.42,-8.61 12.26,-4.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1269.94 1385.89c2.45,-3.4 3.22,-6.11 4.68,-8.35 2.22,-3.49 5.53,-3.62 8.8,-1.71 2.46,1.4 4.14,3.6 3.64,6.63 -0.79,4.76 -4.35,6.41 -8.55,7.57 -4,1.1 -5.16,-5.12 -8.85,-3.97 0.08,-0.07 0.16,-0.09 0.29,-0.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1268.62 1386.51c0.37,-0.21 0.69,-0.36 1.03,-0.45 -1.01,0.62 -0.88,0.44 -1.03,0.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M142.16 831.03c-3.6,-0.64 -5.85,-3.02 -6.26,-6.79 -0.31,-3.19 1.89,-5.01 4.17,-6.38 3.85,-2.28 7.72,-1.18 12.25,1.55 -2.11,10.11 -4.57,12.61 -10.15,11.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M504.39 266.02c6.04,8.64 0.07,11.46 -5.29,14.59 -8.03,-11.71 -7.89,-12.09 5.29,-14.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M867.99 944.2c1.23,4.87 -1.13,8.05 -5.92,9.26 -1.3,0.36 -2.72,0.26 -5.41,-0.07 -2.64,-1.89 -4.75,-3.23 -5.14,-5.04 -1.12,-5.08 2.2,-7.69 6.45,-9.05 4.17,-1.37 8.98,0.88 10.02,4.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M892.89 874.12c0.15,0.62 0.32,1.2 0.45,1.87 -0.67,1.64 -0.67,1.64 -0.67,1.8 -0.21,-1.33 -0.13,-2.55 0.22,-3.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M894.82 855.44c1.64,-0.51 4.2,-0.2 5.52,0.86 3.04,2.36 3.33,6.12 1.26,9.19 -1.49,2.19 -4.09,3.63 -6.24,5.28 -1.28,0.95 -2.06,2.11 -2.47,3.36 -1.02,-4.39 -2.68,-7.65 -3.41,-11.08 -0.94,-3.91 1.85,-6.56 5.34,-7.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M312.72 548.98c-2.09,2.19 -4.85,2.74 -7.5,1.43 -2.73,-1.37 -4.06,-4.25 -3.02,-6.96 1.98,-5.18 4.68,-10.1 9.17,-13.91 6.73,11.02 6.7,13.89 1.35,19.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M512.87 1283.7c-3.8,-2.03 -3.16,-5.32 -0.47,-9.63 3.29,-2.18 5.61,-3.93 8.09,-4.33 1.47,-0.23 3.88,1.33 4.78,2.8 2.02,3.23 0.94,6.66 -1.44,9.35 -3.07,3.43 -7.06,3.93 -10.97,1.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1818.95 934.04c-2.25,2.69 -7.63,2.52 -10.71,-0.69 -1.23,-1.26 -1.26,-3.69 -1.6,-6.9 1.02,-2.37 1.65,-3.74 2.68,-4.47 4.24,-3.02 7.63,-1.68 9.86,2.58 1.65,3.06 2.3,6.45 -0.24,9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1996.45 1078.66c-3.66,1.51 -6.5,-0.75 -8.38,-3.63 -1,-1.56 -1.1,-3.73 -1.21,-6.75 1.92,-3.8 4.43,-4.45 7.2,-4.17 3.62,0.42 6.27,2.18 6.57,6.17 0.26,3.59 -0.75,6.96 -4.19,8.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M154.02 1320.73c0.78,4.81 -0.44,7.75 -4.4,8.49 -2.8,0.55 -5.4,-0.75 -6.46,-3.45 -1.25,-3.37 -0.39,-6.83 2.61,-8.93 3.53,-2.48 6.12,-0.61 8.25,3.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1417.71 967.63c-5.86,0.68 -8.71,-2.36 -9.06,-8.04 -0.04,-0.68 0.32,-1.32 1.16,-3.05 8.89,-3.15 11.44,-2.22 12.65,3.46 0.79,3.61 -1.29,7.21 -4.75,7.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1155.87 994.05c10.08,4.57 10.77,5.07 6.58,11.32 -2.76,4.22 -2.91,13.47 -8.95,11.83 -8.43,-2.3 0.86,-8.66 -0.07,-13.43 -0.63,-3.15 0.56,-6.72 2.45,-9.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1407.92 1493.73c-0.81,2.46 -1.26,3.82 -2.15,4.75 -2.6,2.76 -5.71,3.74 -8.87,1.1 -2.26,-1.89 -2.61,-4.74 -1.93,-7.45 0.89,-3.54 3.13,-6.23 6.96,-6.39 4.3,-0.15 5.3,3.28 5.99,7.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1551.28 1674.78c-1.62,0.46 -4.25,-0.21 -5.46,-1.39 -2.49,-2.43 -4.16,-5.83 -2.55,-9.37 1.76,-3.88 4.49,-7.06 10.49,-4.19 1.49,2.92 2.3,4.91 2.48,6.94 0.35,3.81 -1.36,6.89 -4.96,8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1077.93 1318.84c-5.82,1.37 -11.79,3 -17.66,1.28 -3,-0.92 -3.38,-3.91 -2.35,-6.71 1.1,-2.96 3.77,-3.55 8.04,-3.43 4.79,0.13 8.11,-0.11 11.46,-0.1 2.45,0.08 3.19,2.06 3.41,4.15 0.22,2.27 -1.02,4.35 -2.9,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M624.28 367.91c-5.44,-2.87 -11.68,-4.53 -8.29,-10.82 2.53,-4.62 7.37,-1.46 11.13,-0.4 2.57,0.77 5.13,1.76 7.55,2.97 2.97,1.46 2.31,6.43 -0.96,8.43 -2.61,1.57 -5.24,1.11 -9.42,-0.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M180.07 257.34c-0.21,-2.49 -0.46,-4.14 0.22,-5.03 4.01,-5.42 8.27,-6.53 11.32,-3.25 3.19,3.42 2.85,8.98 -1.41,12.41 -4.17,3.37 -7.25,0.8 -10.13,-4.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M564 552.08c2.5,-0.01 3.88,0.04 5.05,0.6 3.26,1.51 5.38,3.83 4.61,7.82 -0.56,2.92 -2.55,4.68 -5.29,5.26 -3.54,0.78 -6.78,-0.19 -8.64,-3.26 -2.52,-4.21 -0.84,-7.6 4.25,-10.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M652.3 569.29c-3.02,-2.3 -2.43,-7.65 0.75,-11.01 2.09,-2.15 4.85,-3.1 7.4,-1.94 3.46,1.53 4.59,4.74 3.08,9.69 -3.62,4.62 -7.22,6.35 -11.23,3.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M260.12 240.57c-4.36,-1.5 -7.24,-6.04 -5.45,-9.33 2.55,-4.73 6.63,-3.61 10.57,-2.1 0.64,0.23 1.15,0.68 2.28,2.15 -1.57,8.84 -3.35,10.68 -7.4,9.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1180.84 250.44c-2.96,-2.63 -2.35,-7.46 0.95,-11.14 3.08,-3.39 5.86,-2.51 10.9,4.68 -0.27,2.59 -0.31,4.23 -1.18,5.11 -3.09,3.55 -6.87,4.72 -10.67,1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1463.09 508.16c-3.03,-0.73 -5.26,-1.2 -6.48,-2.63 -3.13,-3.48 -3.06,-7.59 -0.35,-11.42 0.69,-0.96 2.3,-1.96 3.44,-1.87 5.04,0.36 6.64,4.3 7.56,8.45 0.63,2.92 -0.43,5.46 -4.17,7.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M919.75 1958.23c1.47,-0.66 4.11,-0.32 5.49,0.63 3.61,2.52 3.45,8.46 -0.69,12.34 -3.76,3.58 -7.23,2.52 -9.52,-3.59 -0.21,-5.01 1.57,-7.94 4.72,-9.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M397.19 801.76c-2.61,-1.26 -3.59,-3.86 -3,-6.82 0.58,-2.95 2.64,-4.75 5.33,-5.65 5.97,-1.94 10.36,2.04 9.51,8.73 -0.33,2.68 -1.18,5.28 -2.98,7.03 -3.8,-1.61 -6.48,-2.06 -8.87,-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M840.06 1590.06c4.72,5.26 4.89,8.5 -0.18,15.54 -5.84,-2.37 -8.22,-6.31 -8.05,-11.4 0.06,-1.69 1.45,-3.81 2.87,-4.91 1.63,-1.33 3.93,-0.86 5.37,0.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M215.44 768.42c-2.91,0.03 -4.94,-1.94 -5.42,-4.99 -0.5,-3.09 0.99,-5.45 3.31,-7.01 3.69,-2.46 7.67,-2.72 11.41,-0.15 3.1,2.13 4.4,5 1.75,9.72 -4.41,1.46 -7.69,2.35 -11.04,2.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M816.37 1003.45c-3.76,-2.47 -4.99,-7.24 -2.43,-12.6 2.52,-5.22 6.37,-3.38 10.63,0.21 1.8,5.35 1.11,9.17 -2.63,11.86 -1.62,1.18 -3.6,1.85 -5.57,0.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M470.12 697.79c1.56,1.45 2.01,1.94 2.34,2.53 1.34,2.5 2.15,5.32 0.32,7.69 -1.6,2.05 -3.78,3.97 -6.12,4.95 -3.56,1.49 -7.84,-1.64 -8.99,-5.98 -1.23,-4.7 0.58,-7.41 7.36,-10.27 1.1,-0.43 2.62,0.11 5.09,1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1265.78 1243.48c1.19,1.67 1.98,3.51 0.89,5.62 -2.03,3.99 -7.61,5.63 -12.16,2.89 -4.55,-2.76 -3.91,-6.45 0.93,-10.46 4.79,-1.33 8.04,-1.27 10.34,1.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M810.93 235.37c-2.87,-3.68 -5.49,-6.03 -6.86,-9 -1.25,-2.75 0.84,-5.02 3.45,-6.39 3.31,-1.71 7.26,-2.42 9.04,0.86 2.87,5.3 3.58,11.55 0.21,17.09 -0.9,1.5 -3.55,-0.04 -5.84,-2.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1085.51 1261.38c-1.16,-5.12 -0.17,-9.54 4.56,-12.19 1.47,-0.82 3.88,-0.67 5.58,-0.13 2.07,0.68 2.73,2.89 2.19,5.01 -0.48,1.96 -1.42,3.8 -2.86,6.76 -6.27,4.44 -8.67,4.23 -9.46,0.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1140.35 940.25c-1.66,-2.18 -3,-2.57 -4.08,-3.28 -3.84,-2.53 -5.68,-5.9 -2.5,-10.07 2.4,-3.1 5.8,-3.23 8.9,-0.97 3.48,2.46 2.68,5.82 0.93,8.94 -1.27,2.28 -3.87,3.89 -3.24,5.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M513.65 2094c-0.95,-4.33 -0.11,-8.31 4.17,-10.52 3.73,-1.93 6.41,-0.38 8.49,4.25 -0.39,6.05 -3.65,8.23 -7.94,9.12 -2.11,0.46 -4.22,-0.54 -4.71,-2.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M565.77 917.08c-1.26,-3.59 0.73,-6.48 3.79,-8.48 4.34,-2.87 8.93,-2.31 14.47,0.5 0.44,8.01 -5.3,9.3 -10.06,11.32 -3.44,1.38 -6.93,0.43 -8.2,-3.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M966.78 1884.55c3.36,1.76 4.42,5.08 3.1,8.65 -1.29,3.43 -4.47,4.97 -8.91,6.22 -6.79,-3.44 -5.01,-8.11 -2.8,-12.38 1.8,-3.49 5.24,-4.3 8.61,-2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1363.93 716.11c-0.85,-4.12 -1.42,-6.9 0.54,-9.31 2.51,-3.16 5.67,-3.74 9.04,-1.9 3.9,2.12 5.47,7.26 3.08,10.5 -3.29,4.45 -7.28,6.38 -12.66,0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1662.84 756.75c-5.09,1.86 -7.05,-2.13 -8.66,-6.07 -0.78,-1.85 -1.97,-3.54 -2.79,-5.38 -1.15,-2.85 1.06,-5.37 4.44,-4.62 3.26,0.72 6.32,2.2 10.3,4.56 1.74,5.59 1.21,9.85 -3.28,11.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M464.16 630.07c-2.84,-2.38 -2,-7.25 1.24,-7.94 2.51,-0.55 5.27,-0.74 7.76,-0.24 5.99,1.25 6.11,5.04 -0.72,11.03 -3.6,-0.81 -6.35,-1.33 -8.28,-2.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M318.75 724.97c-0.92,-2.83 -0.22,-5.38 2.82,-8.35 3.1,-0.46 5.22,-0.54 7,0.16 2.86,1.05 4.17,3.59 3.57,6.56 -0.81,3.83 -3.79,5.78 -7.36,6.15 -2.99,0.31 -5.04,-1.73 -6.03,-4.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M373.4 648.04c-2.31,-3.46 -1.14,-5.62 6.86,-10.23 7.7,5.71 8.47,9.41 3.8,12.23 -4.02,2.46 -8.24,1.65 -10.67,-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M372.27 58.89c-4.67,1.2 -10.13,-1.83 -10.59,-6.63 -0.54,-5.59 3.72,-6.33 9.12,-5.59 3.14,2.39 4.73,4.57 4.61,7.48 -0.12,2.08 -0.84,4.16 -3.14,4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1489.35 1131.77c4.04,-7.81 6.03,-8.74 9.72,-6.29 3.07,2.09 4.41,5.03 3.26,8.53 -1.2,3.65 -6.12,3.84 -11.65,0.75 -0.52,-0.28 -0.71,-1.11 -1.32,-2.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1064.71 893.15c-0.79,-4.54 1.94,-8.41 6.16,-8.66 4.49,-0.27 5.98,1.96 5.57,10.57 -8.62,2.99 -11.05,2.31 -11.73,-1.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M574.32 1098.05c4.09,-1.37 6.83,-1.74 9.25,-0.04 1.67,1.21 3.33,2.52 2.87,4.97 -0.92,4.65 -4.25,7.03 -8.4,8.03 -2.77,0.68 -5.44,-0.14 -6.96,-2.91 -1.93,-3.59 -0.69,-6.58 3.24,-10.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1276.59 1624.14c-3.05,0.77 -5.65,-1.4 -6.13,-4.01 -1.12,-5.77 -2.7,-11.78 2.37,-16.96 3.05,3.23 5.17,5.94 6.73,8.87 0.89,1.73 1.39,3.92 1.32,5.82 -0.1,2.83 -1.39,5.56 -4.29,6.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1656.31 805.98c-3.73,1.79 -6.71,0.12 -8.55,-3.04 -2.45,-4.15 -1.43,-7.84 4.15,-10.66 5.3,0.33 7.06,3.05 7.48,6.7 0.36,2.85 -0.29,5.65 -3.09,7.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M672.92 1011.09c-0.19,1.29 -0.36,2.61 -2.06,3.3 -12.42,-2.21 -11.77,-10.76 -11.95,-18.66 0.03,0.13 -0.13,-0.04 1.56,0.21 14.35,3.23 14.35,3.23 12.45,15.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M742.98 1097.97c-1.55,-1.28 -3.34,-2.54 -4.21,-4.24 -1.39,-2.83 -0.46,-5.44 2.51,-6.76 2.68,-1.21 5.24,-0.33 8.51,2.1 3.18,3.62 5.09,6.78 2.11,9.9 -3.01,3.14 -6.24,1.27 -8.93,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1257.77 1953.69c-1.54,-2.45 -1.74,-5.5 0.75,-7.48 1.47,-1.13 4.07,-2.2 5.6,-1.69 4.12,1.35 3.74,5.03 2.39,9.66 -4.07,4.66 -6.72,2.66 -8.74,-0.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1742.63 1297.86c1.71,0.44 3.59,1.8 4.53,3.32 1.99,3.22 0.72,6.39 -2.64,10.07 -3.23,0.65 -5.37,0.98 -7.1,0.29 -3.3,-1.44 -5.07,-4.19 -3.97,-8.07 1.21,-4.26 4.92,-6.72 9.18,-5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M954.7 180.17c-2.73,-2.41 -3.51,-5.57 -2.08,-10.4 4.01,-3.24 7.19,-3.21 10.24,-1.31 3.82,2.43 4.53,6.46 2.08,10.5 -2.34,3.83 -6.68,4.37 -10.24,1.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1659.41 303.35c-3.69,1.32 -6.72,-0.56 -8.34,-3.85 -0.78,-1.62 -0.34,-3.86 0.34,-6.96 2.73,-1.67 4.72,-2.78 6.51,-2.51 3.79,0.49 5.86,3.22 5.98,7.05 0.1,3.06 -1.9,5.36 -4.48,6.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M769.14 212.97c-2.34,-2.65 -2.85,-6.46 -0.27,-9.29 3.71,-3.98 7.16,-1.77 10.2,1.4 0.45,0.48 0.82,1.07 1.57,2.89 -0.12,2.54 -0.26,4.1 -1.11,4.91 -3.36,3.49 -7.22,3.63 -10.4,0.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1154.16 993.76c-1.35,-0.7 -2.03,-1.54 -2.3,-2.47 0.61,0.25 1.23,0.47 1.9,0.82 0.63,1.6 0.46,1.58 0.4,1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1144.94 989.92c-3.03,-0.48 -4.93,-2.48 -4.64,-5.66 0.21,-3.22 2.83,-4.65 5.59,-5.24 3.05,-0.7 5.12,0.75 6.4,3.7 1.15,2.65 -1.28,5.92 -0.43,8.55 -2.54,-0.91 -4.75,-1.02 -6.92,-1.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M484.57 784.63c3.23,-1.66 7.35,0.28 7.76,3.68 0.59,4.58 -0.84,8.05 -6.28,7.98 -0.64,-0.01 -1.24,-0.33 -2.86,-1.26 -4.5,-4.96 -2.83,-8.2 1.37,-10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M963.37 1674.41c4.1,2.6 4.72,6.39 0.87,10.15 -0.45,0.47 -1.12,0.74 -2.96,1.36 -6.48,-0.47 -8.33,-3.3 -6.13,-8.23 1.69,-3.57 4.72,-5.5 8.22,-3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1416.85 506.49c-1.21,0.38 -2.62,0.01 -4.97,-0.76 -1.61,-1.91 -2.5,-3 -2.69,-4.29 -0.64,-4.01 1.49,-6.47 5.14,-7.31 3.77,-0.92 6.56,0.84 7.29,4.7 0.68,3.72 -1.07,6.55 -4.76,7.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1056.08 421.74c5.01,-1.24 8.23,0.83 8.35,5.95 0.1,3.76 -2.3,6.86 -6.35,6.84 -4.55,-0.03 -5.02,-3.86 -5.32,-7.39 -0.06,-0.69 0.25,-1.39 0.98,-3.17 1.2,-1.47 1.73,-2.07 2.34,-2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M363.94 1249.7c-1.81,-4.13 0.93,-6.37 3.95,-8.27 0.57,-0.32 1.37,-0.31 3.18,-0.17 5.78,3.18 5.91,6.73 1.83,10.18 -2.82,2.39 -7.58,1.29 -8.96,-1.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M357.19 1512.63c3.98,-0.87 7.36,3.29 6.56,8.12 -0.52,3.09 -2.93,4.45 -7.02,4.68 -2.28,-1.81 -4.01,-3.32 -4.42,-5.11 -0.79,-3.85 0.82,-6.84 4.89,-7.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M790.63 406.58c-1.8,3.78 -5.19,3.93 -8.57,3.02 -3.38,-0.91 -5.92,-3.1 -7.12,-6.49 -1.08,-3.14 0.38,-5.44 3.29,-6.16 1.83,-0.47 3.93,0.21 7.3,0.97 4.33,2.42 6.94,4.63 5.1,8.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M523.61 1521.45c6,0.5 11.54,-2.26 17.12,2.3 -5.66,2.98 -9.73,5.44 -14.06,7.31 -3.38,1.49 -7.17,1.29 -8.48,-2.84 -0.94,-2.94 1.64,-4.99 5.42,-6.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M555.17 1323.66c-2.87,5.99 -7.17,6.32 -14.78,0.24 1.4,-5.91 4.71,-7.96 9.13,-8.64 2.39,-0.32 4.25,0.82 5.07,2.67 0.77,1.71 1.3,4.22 0.58,5.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1981.94 776.15c-1.29,-1.04 -2.34,-3.66 -2.01,-5.25 0.71,-3.44 3.17,-6.17 6.84,-6.35 3.96,-0.21 5.91,2.29 5.32,7.58 -2.94,4.92 -6.01,7.28 -10.15,4.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M686.25 510.94c-1.06,-1.39 -1.88,-3.76 -1.55,-5.39 0.82,-3.67 3.87,-5.17 8.69,-5.35 5.8,3.39 7.86,7.19 3.35,11.74 -2.94,2.97 -7.71,2.44 -10.49,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1288.69 1877.01c-3.55,-1.49 -4.4,-6.89 -1.54,-10.43 1.86,-2.28 4.59,-2.37 8.37,-0.68 3.05,3.02 3.17,5.49 1.63,8.07 -1.98,3.29 -4.95,4.53 -8.46,3.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M447.04 509.02c3.46,0.57 5.52,0.87 7.33,1.69 3.2,1.51 6.04,3.69 4.21,7.86 -1.76,3.97 -5.38,3.59 -8.82,2.79 -3.43,-0.81 -6.26,-2.7 -7.6,-6.14 -1.2,-3.11 0.48,-5.12 4.88,-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M901.07 675.83c-1.32,4.57 -4.42,6.34 -10.04,3.08 -3.47,-3.41 -5.54,-6.51 -2.23,-9.42 3.51,-3.15 7.56,-1.8 10.63,1.09 1.18,1.12 2.09,3.75 1.64,5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M801.53 617.68c3.47,-1.52 6.64,-0.58 8.37,3.13 1.83,3.93 -0.49,8.09 -5.23,8.75 -1.76,0.27 -3.73,-1.06 -6.4,-2.74 -2.15,-5.1 -0.03,-7.7 3.26,-9.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1266.83 1298.79c2.82,2.91 1.94,8.22 -1.67,10.46 -4.14,2.59 -7.51,1.46 -9.92,-4.15 0.86,-3.11 1.47,-5.19 2.81,-6.49 2.85,-2.84 6.17,-2.52 8.77,0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1103.36 1084.93c-2.43,4.78 -6.67,6.31 -9.96,3.88 -4.29,-3.18 -3.01,-6.91 0.25,-10.25 0.45,-0.47 1.11,-0.72 2.99,-1.37 5.41,0.81 9.65,2.2 6.73,7.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M616.52 900.85c1.83,1.87 4.25,3.85 1.96,6.74 -1.91,2.38 -4.84,2.04 -7.17,0.83 -2.28,-1.2 -4.93,-2.65 -6.09,-4.76 -2.68,-4.68 -0.54,-7.36 5.74,-7.24 2.59,1.84 4.18,3.07 5.56,4.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1450.07 1215.35c-4.96,-1.19 -5.33,-5.12 -4.02,-9.43 0.18,-0.56 0.75,-1.05 2.18,-2.37 8.56,1.06 10.12,2.52 9.14,6.81 -0.95,3.93 -3.61,5.9 -7.29,4.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1041.66 1303.44c1.56,2.31 -0.23,9.63 -2.44,10.76 -0.76,0.38 -2.35,-0.18 -3.08,-0.84 -2.59,-2.3 -3.98,-5.19 -2.28,-9.78 3.31,-2.18 6,-2.74 7.8,-0.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M919.52 653.81c-1.59,3.89 -7.21,4.83 -10.14,1.68 -3.47,-3.73 -2.31,-7.18 3.46,-9.63 5.7,0.66 8.71,2.99 6.68,7.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1019.76 925.51c0.36,-4.12 1.9,-6.28 4.49,-7.38 3.23,-1.34 6.44,-1.49 8.78,1.79 2.27,3.16 0.83,7.69 -3.25,10.02 -4.31,2.45 -7.53,1.06 -10.02,-4.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1186.57 1254.57c1.95,-0.26 2.65,-0.28 3.23,0.02 4.33,2.06 6.11,5.31 3.3,9.67 -2.32,3.62 -7.94,4.72 -10.6,2.11 -3.63,-3.57 -2.53,-7.21 1.03,-10.38 0.52,-0.42 1.13,-0.76 3.03,-1.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M68.79 1557.75c1.04,-0.07 2.53,1.1 3.11,2.15 0.65,1.04 1,2.9 0.47,3.82 -3,5.14 -8.38,7.33 -13.35,9.18 -2.86,1.08 -4.11,-2.53 -3.1,-6.88 3.98,-4.97 7.76,-8.01 12.87,-8.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1326.23 973.75c-0.12,-1.72 0.99,-4.11 2.34,-5.31 3.22,-2.87 6.34,-1.3 9.78,2.33 -0.64,8.89 -2.66,11.46 -6.51,10.6 -3.95,-0.89 -5.45,-4.08 -5.61,-7.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M757.96 843.13c-3.33,0.01 -5.51,0.1 -7.21,-0.84 -1.48,-0.85 -2.95,-2.58 -3.44,-4.25 -0.61,-2.23 1.23,-3.96 3.11,-4.66 2.44,-0.89 5.08,-1.59 7.65,-1.58 2.79,0.04 5.15,1.86 5.55,4.8 0.46,3.1 -1.91,4.81 -5.67,6.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M419.44 1661.87c4.67,4.9 0.37,8.29 -2.63,11.79 -0.42,0.49 -0.98,0.93 -2.65,1.81 -5.52,-6.15 -5.38,-10.32 -0.07,-13.76 1.26,-0.88 4.43,-0.79 5.35,0.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M625.83 236.06c1.84,2.49 0.93,5.31 -1.85,6.67 -4.99,2.49 -7.76,0.22 -8.93,-8.5 5.06,-3.84 8.35,-1.54 10.79,1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M417.85 1312.36c3.88,-1.47 6.39,0.48 8.32,5.04 -0.29,4.27 -2.07,6.15 -4.95,6.93 -3.72,0.95 -6.82,-0.05 -7.97,-3.98 -1.1,-3.89 1.05,-6.6 4.6,-7.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M740.56 801.24c2.38,-3.53 5.9,-3.56 8.9,-1.49 4.51,3.11 3.79,6.64 -1.63,10.23 -7.62,-2.23 -9.65,-5.13 -7.27,-8.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1127.56 860.57c0.05,2.07 -2.11,3.46 -4.24,3.4 -3.99,-0.13 -8.23,-0.02 -10.99,-5.28 3.4,-6.86 7.98,-5.2 12.25,-2.87 1.45,0.79 2.91,3.1 2.98,4.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M405.69 356.51c-2.85,-4.31 -4.89,-8.23 1.22,-9.62 3.49,-0.82 6.84,1.18 7.12,4.95 0.37,5.18 -2.56,7.04 -8.34,4.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M76.21 1532.44c2.38,-1.65 5.74,-1.29 6.98,1.26 2.33,4.69 0.26,7.58 -5.99,8.07 -6.26,-3.14 -5.02,-6.44 -0.99,-9.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M449.7 351.17c-0.28,-1.67 0.38,-4.09 1.52,-5.33 1.83,-2.07 4.59,-2.27 8.28,-0.77 2.53,3.08 3.15,5.78 1.7,8.2 -0.94,1.5 -2.87,3.05 -4.49,3.26 -3.71,0.45 -6.37,-1.72 -7.01,-5.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M962.47 564.23c-1.12,-1.17 -1.44,-4.01 -0.96,-5.75 0.8,-2.92 3.49,-4.16 6.45,-3.82 1.24,0.14 2.38,1.17 4.26,2.83 1.39,3.12 1.16,5.32 -0.52,6.67 -2.96,2.39 -6.5,2.9 -9.23,0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1703.04 748.12c-4.16,0.89 -5.93,-1.5 -5.88,-6.43 1.39,-2 2.16,-3.31 3.27,-3.82 3.48,-1.6 6.77,-0.75 7.73,3.06 0.98,3.77 -1.46,6.42 -5.13,7.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1221.97 418.29c-0.94,-2.51 -1.27,-3.88 -1.13,-5.25 0.32,-3.2 2.63,-4.55 5.46,-5.24 2.27,-0.57 4.08,0.45 5.2,2.23 2.13,3.34 1.4,6.79 -1.25,9.35 -2.12,2.03 -4.95,1.9 -8.27,-1.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M888.64 1447.73c5.8,0.33 5.47,4.64 3.52,10.12 -5,4.41 -8.48,4.04 -9.69,-1.46 -1.01,-4.75 1.94,-8.94 6.17,-8.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M150.61 1970.96c3.18,6.11 -0.19,9.96 -8.9,8.42 -1.32,-4.62 -1.02,-7.85 2.26,-9.96 2.67,-1.71 5.21,-1.19 6.63,1.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1259.99 795.98c-2.48,-2.96 -1.9,-6.55 0.06,-9.7 2.3,-3.79 5.48,-3.55 9.62,-0.24 1.24,4.92 0.77,8.26 -2.36,10.65 -2.68,2.01 -5.44,1.51 -7.32,-0.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1431.76 832.71c-4.93,-0.89 -6.52,-4.01 -3.09,-9.61 5.73,-1.81 9.09,-0.45 8.69,5.1 -0.26,2.92 -2.69,5 -5.6,4.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M665.79 397.87c-2.67,-1.12 -4.5,-3.23 -4.64,-6.18 -0.1,-3.06 1.89,-5.01 5.77,-6.52 2.94,0.72 4.98,1.39 6.21,2.8 1.97,2.3 1.89,5.2 -0.09,7.58 -1.85,2.21 -4.3,3.57 -7.25,2.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M197.04 1955.25c2.4,5.2 -1.08,7.31 -6.8,8.21 -5.6,-3.26 -5.91,-6.86 -1.72,-9.98 2.94,-2.17 6.8,-1.92 8.53,1.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1154.88 2284.36c1.77,-0.34 3.72,0.6 6.49,1.99 0.75,2.98 1.12,5.16 0.36,6.8 -1.22,2.75 -4.13,3.69 -6.76,3.12 -2.73,-0.61 -4.54,-2.92 -4.42,-5.89 0.12,-2.74 1.29,-5.5 4.33,-6.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M2031.26 858.53c-1.12,-0.44 -1.97,-1.66 -3.13,-3.57 0.96,-2.57 1.79,-4.63 3.28,-5.44 2.52,-1.4 5.39,-0.69 6.77,1.81 0.8,1.44 0.68,3.98 -0.11,5.45 -1.38,2.79 -4.23,2.75 -6.81,1.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1161.83 2263.75c0.59,-5.63 1.96,-9.77 7.27,-7.87 3.84,1.38 3,5.35 2.14,8.63 -0.2,0.61 -0.58,1.21 -0.9,1.78 -1.68,3.38 -4.2,3.02 -8.51,-2.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1171.24 1340.14c-3.87,-5.68 -3.41,-8.47 3.47,-15.29 8.54,4.93 3.72,10.37 1.37,15.41 -0.93,1.98 -3.56,1.73 -4.84,-0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M975.29 1556.69c3.11,2.72 1.47,8.23 -2.97,9.72 -4.51,1.5 -5.84,-1.57 -5.59,-6.54 2.3,-4.86 5.42,-5.9 8.56,-3.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M855.21 800.41c-0.29,0.5 -0.64,1.02 -1.06,1.58 -5.56,1.64 -9.28,0.84 -11.28,-3.77 -1.09,-2.52 -1.79,-5.22 -3.1,-7.58 -1.25,-2.19 -3.53,-1.83 -5.33,-0.76 -1.01,0.6 -1.87,2.01 -2.17,3.21 -1.59,5.98 4.16,10.11 3.81,16.88 -8.72,3.61 -15.39,10.02 -18.5,20.02 -0.8,2.59 -4.53,3.23 -7.02,1.17 -2.08,-1.71 -3.64,-4.01 -4.78,-8.39 2.12,-8.84 2.12,-16.23 6.87,-21.21 5.8,-6.07 -0.53,-14.25 5.43,-20.38 -0.28,-0.46 -0.59,-0.96 -0.9,-1.59 -1.34,-5.12 -2.37,-9 -3.49,-12.82 -2,-6.89 1.02,-11.58 6.46,-15.3 2.68,-1.77 5.49,-2.88 8.55,-1.35 0.43,-0.68 0.82,-1.32 1.34,-2.04 1.38,-1.88 2.45,-2.51 5.05,-3.12 0.16,-0.09 0.32,-0.13 0.48,-0.22 -0.31,-0.15 -0.64,-0.3 -0.97,-0.52 5.16,-1.69 8.91,-5.28 12.82,-3.06 0.78,-0.36 1.54,-0.8 2.3,-1.35 2.39,-0.03 3.85,0.34 5.97,1.47 0.14,-0.54 0.34,-1.08 0.69,-1.73 9.1,-4.67 18.22,0.25 26.3,-4.38 0.93,-0.55 4.4,1.26 4.97,2.66 1.47,3.7 0.82,8.76 3.12,11.47 3.69,4.44 8.65,-2.36 13.26,-0.47 2.48,1.05 6.12,1.27 7.34,3.15 3.8,5.99 8.49,5.37 14.08,3.52 1.55,-0.48 3.96,0.56 4.1,3.38 0.1,2.35 -1.17,3.65 -2.76,5.08 -4.6,4.23 -10.66,-2.27 -15.4,2.69 -4.19,4.37 -9.78,4.62 -15.39,3.49 -2.74,-0.54 -4.67,1.06 -7.63,2.03 0.09,0.81 0.18,1.59 0.18,2.47 -1.25,3.98 -2.45,6.55 -4.63,10.1 -0.14,0.1 -0.28,0.19 -0.42,0.29 0.45,0.05 0.9,0.09 1.34,0.15 -2.24,5.11 -4.71,8.68 -9.56,8.4 -0.29,0.33 -0.58,0.68 -0.92,1.01 -0.25,-0.25 0.28,0.22 -0.91,0.8 -0.3,0.27 -0.59,0.51 -0.87,0.77 0.5,0.06 0.99,0.08 1.48,0.14 -9.29,10.67 -9.29,10.67 -18.78,4.22 -0.02,-0.05 -0.03,-0.1 -0.06,-0.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1181.56 1043.19c2.62,-2.75 5.94,-0.96 9.5,6.4 -3.15,5.36 -6.5,6.56 -10.05,2.62 -2.55,-2.91 -2.01,-6.33 0.55,-9.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M419.46 306.57c-5.33,0.26 -9.23,-1.46 -8.59,-9.08 4.67,-4.15 8.51,-3.58 11.85,-0.81 1.34,1.1 2.45,3.46 2.32,5.16 -0.24,2.93 -2.67,4.58 -5.58,4.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1015.5 1714.29c0.38,-4.45 1.63,-8.4 8.37,-6.69 2.98,4.3 1.6,7.34 -1.18,9.93 -1.61,1.53 -3.86,1.59 -5.57,0.25 -0.89,-0.72 -1.69,-2.34 -1.61,-3.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M973.86 925.13c-2.77,-1.05 -4.51,-3.57 -4.01,-6.47 0.53,-2.98 3.21,-4.44 6.17,-4.31 2.97,0.15 5.1,1.9 5.64,4.96 0.47,2.65 0.52,5.42 0.89,8.24 -0.07,-0.06 -0.35,-0.34 -1.3,-0.82 -3.39,-0.93 -5.54,-0.89 -7.39,-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M982.55 927.56c0.01,0 0,0 0,0 0.02,0.03 0.03,0.04 0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1260.04 659.6c2.72,3.82 1.58,6.12 -5.77,9.06 -4.59,-2.79 -8.15,-5.29 -4.34,-9.85 3.06,-3.59 7.46,-3 10.12,0.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1303.55 1203.81c3.26,4.27 -0.45,7.36 -3.54,10.07 -0.48,0.38 -1.22,0.48 -3.07,0.63 -5.38,-2.92 -5.98,-6.5 -2.27,-9.99 2.56,-2.39 6.51,-3.84 8.88,-0.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1210.61 1512.13c-4.54,-1.84 -4.91,-5.65 -2.81,-9.9 0.33,-0.64 0.78,-1.13 2.51,-2.26 8.12,1.85 10,4.12 8.21,8.11 -1.55,3.39 -4.34,5.51 -7.91,4.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1293.22 379.39c-1.45,-2.48 -2.41,-4.53 -2.07,-6.35 0.51,-3.12 2.97,-4.45 5.99,-3.99 3.4,0.55 4.74,4.63 2.27,8.16 -0.98,1.41 -3.4,1.82 -6.19,2.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M927.8 481.5c-4,1.4 -8.25,-2.04 -7.99,-6.65 0.33,-5.88 4.34,-6.09 9.9,-4 3.62,5.17 3.1,8.88 -1.92,10.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M513.25 1693.67c-0.26,0.61 -0.82,1.09 -2.45,2.43 -6.28,1.49 -9.37,-0.5 -8.3,-5.86 0.89,-4.47 5.9,-7.15 9.39,-5.36 3.98,2.06 2.96,5.53 1.35,8.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1307.99 1390.05c-3.58,2.22 -6.18,0.26 -8.28,-4.37 0.77,-4.86 2.72,-7.39 6.35,-8.27 2.18,-0.53 4.06,0.31 4.89,2.21 1.84,4.18 0.93,8 -2.96,10.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M738.92 1238.68c1.15,-1.47 3.09,-2.57 4.91,-3.12 2.08,-0.6 4.27,0.28 5,2.36 0.62,1.75 0.88,3.98 0.36,5.77 -1.07,3.76 -4.31,5.06 -9.19,5.03 -3.44,-3.75 -3.37,-7.08 -1.09,-10.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1305.12 2330.92c-0.17,4.44 -3.43,7.14 -7.63,7.55 -1.18,0.12 -3.68,-2.34 -3.63,-3.53 0.1,-2.46 1.56,-4.85 3.53,-8.02 5.01,-1.55 7.85,-0.01 7.73,4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1082.85 1111.89c6.26,-5.52 9.9,-5.18 10.41,-0.33 0.42,3.74 -0.65,7.22 -4.57,8 -4.4,0.87 -5.62,-2.68 -5.84,-7.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1036.5 1099.45c6.07,5.04 6.45,7.81 2.73,10.99 -2.22,1.9 -5,2.82 -7.26,0.59 -1.28,-1.24 -2.1,-3.64 -1.96,-5.44 0.22,-2.91 2.57,-4.69 6.49,-6.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1065.29 1109.73c1.78,4.25 -0.62,9.18 -4.55,9.62 -4.66,0.51 -5.06,-3.35 -5.42,-6.79 -0.09,-0.64 0.11,-1.32 0.93,-3.1 3.99,-3.26 7.31,-3.86 9.04,0.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M477.9 534.09c4.03,1.41 5.02,4.29 0.59,8.51 -1.88,0.84 -2.52,1.12 -3.19,1.22 -4.02,0.58 -7.04,-0.71 -7.01,-5.17 0.03,-3.99 4.59,-6.27 9.61,-4.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M994.85 1779.16c-1.63,2.97 -4.12,5.6 -7.92,3.54 -3.46,-1.88 -3.71,-5.17 -2.24,-8.57 1.17,-2.73 3.62,-3.63 7.59,-2.94 2.99,2.83 3.94,5.49 2.57,7.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1884.91 874.49c-5.51,-2.36 -7.3,-5.41 -3.63,-9.64 1.89,-2.17 4.52,-3.73 7.09,-1.73 4.19,3.23 2.74,6.9 -0.37,10.25 -0.42,0.48 -1.15,0.71 -3.09,1.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1093.42 649.99c-4.13,-1.22 -4.63,-4.78 -2.94,-8.34 0.78,-1.73 2.82,-2.87 5.7,-4.57 5.49,1.2 6.02,4.32 4.91,8.03 -1.16,3.86 -3.75,6.08 -7.66,4.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M326.71 1068.18c4.7,2.12 6.18,4.9 3.3,8.13 -3.06,3.37 -8.32,3.1 -10.04,-0.41 -2.64,-5.36 1.52,-6.75 6.74,-7.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M987.98 1347.12c0.62,4.33 -2.11,6.69 -5.46,7.72 -4.18,1.31 -6.34,-0.96 -5.89,-6.62 6.81,-5.35 10.77,-5.27 11.35,-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M538.85 894.53c-3.76,8.26 -7.12,10.14 -10.88,7.1 -1.19,-1.02 -2.25,-4.1 -1.59,-5.31 2.67,-5.13 6.94,-5.93 12.47,-1.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M948.02 1381.5c3.65,-4.02 7.07,-2.78 9.7,3.04 -1.27,5.16 -2.17,10.3 -7.79,7.44 -3.96,-2.02 -4.75,-7.32 -1.9,-10.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1100.11 270.57c-5.33,1.18 -6.84,-2.45 -6.96,-8.04 2.96,-2.84 5.7,-2.85 8.09,-1.63 1.55,0.78 3.17,2.58 3.48,4.19 0.63,3.2 -1.98,4.9 -4.6,5.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M390.07 159.04c-1.36,-1.01 -2.63,-3.41 -2.43,-5.03 0.38,-3.21 3.19,-4.39 6.07,-3.78 4.75,0.99 7.18,3.62 3.24,9.34 -3.05,0.3 -5.39,0.49 -6.88,-0.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1070.09 942.58c0.54,3.78 -2.05,6.13 -5.52,7.2 -2.73,0.81 -5.42,0.4 -6.95,-2.23 -2.37,-4.05 0.71,-5.98 4.9,-8.28 4.12,-0.34 7.09,0.28 7.57,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M495.59 394.43c-3.7,-1.79 -4.44,-4.63 -0.84,-8.88 4.92,-1.85 7.87,-0.64 9.2,3 0.57,1.54 0.14,4.29 -0.89,5.43 -2.02,2.2 -4.99,1.68 -7.47,0.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1244.17 584.74c0.52,2.33 0.58,3.91 -0.08,4.9 -2.22,3.14 -5.26,4.32 -8.69,2.13 -2.45,-1.57 -3.68,-4.23 -2.49,-7.02 1.89,-4.36 5.46,-2.8 8.67,-1.95 0.64,0.18 1.19,0.6 2.59,1.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M398.72 465.74c5.44,3.27 6.06,7.02 1.4,9.64 -3.04,1.65 -7.04,-0.02 -8.15,-3.65 -1.33,-4.28 1.7,-5.91 6.75,-5.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1156.18 2459.82c-1.17,5.41 -2.42,10.15 -7.92,7.06 -3.84,-2.22 -3.66,-7.11 0.01,-10.49 3.34,-3.03 6.07,-1.73 7.91,3.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M482.55 483.56c-3.52,3.2 -10.11,1.91 -11.9,-2.2 -0.56,-1.3 0.43,-3.99 1.56,-5.19 1.9,-2.05 4.71,-2.24 8.48,-0.5 2.8,2.99 4.16,5.8 1.86,7.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M360.16 720.09c-1.61,2.54 -4.94,2.61 -7.27,1.05 -4.29,-2.87 -4.81,-6.2 1.45,-9.42 5.85,1.03 8.96,3.36 5.82,8.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M656.14 1224.89c-1.48,-2.62 -0.49,-5.25 1.69,-7.03 3.9,-3.16 7.08,-2.3 9.24,3.4 -1.51,2.66 -2.68,4.28 -4.34,5.25 -2.52,1.56 -5.08,1.07 -6.59,-1.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1353.53 1096.83c-3.57,2.41 -6.24,2.4 -8.2,0.2 -2,-2.23 -2.04,-5.27 0.13,-7.29 2.77,-2.62 6.35,-2.2 9.31,-0.41 3.23,2.02 1.33,4.44 -1.24,7.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M856.73 1314.33c2.5,-3.58 5.81,-2.15 8.5,0.47 0.97,0.91 2.19,1.75 2.81,2.87 0.56,1.01 0.46,2.38 0.62,3.63 -1.82,0.27 -3.66,0.54 -6.8,0.61 -4.68,-1.6 -7.8,-3.72 -5.13,-7.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M303.83 654.96c-0.42,-3.71 0.6,-7.12 4.52,-7.75 3.97,-0.68 5.68,2.58 6.4,7.31 -7.72,5.01 -10.39,4.77 -10.92,0.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M335.9 1119.92c0.56,-2.57 1.95,-5.37 5.27,-4.73 5.59,1.02 4.72,5.17 3.65,9.19 -0.19,0.63 -0.67,1.18 -2.03,2.45 -6.54,0.92 -7.98,-2.27 -6.9,-6.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1117.33 1260.71c1.68,-4.62 3.99,-6.84 7.65,-4.51 3.12,1.97 3.2,6 0.17,8.23 -3.45,2.61 -5.96,0.97 -7.82,-3.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M779.89 281.96c-2.85,0.86 -5.27,-0.62 -6.11,-3.33 -0.81,-2.59 -0.13,-5.27 2.68,-6.64 1.12,-0.56 2.43,-0.62 4.92,-0.17 1.68,1.95 2.44,3.11 2.58,4.3 0.37,3.06 -1.46,5.06 -4.07,5.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1404.28 683.85c0.72,1.02 0.88,2.45 0.51,4.78 -1.98,1.56 -3.21,2.39 -4.44,2.38 -3.09,-0.06 -4.74,-2.11 -4.79,-5.09 -0.01,-1.01 1.04,-2.35 1.97,-3.12 2.53,-2.03 4.97,-1.51 6.76,1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M470.23 567.23c1.44,1.78 1.56,3.85 0.3,5.68 -1.71,2.63 -4.27,3.36 -7.01,1.88 -1.13,-0.6 -1.89,-1.89 -2.9,-4.25 0.75,-2.46 1.42,-3.77 2.45,-4.52 2.65,-1.78 5.16,-1.17 7.15,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1345.29 291.78c0.49,-1.4 3.1,-3.11 4.44,-2.91 5.2,0.83 5.84,4.25 2.4,9.32 -6.2,0.92 -8.58,-1.4 -6.84,-6.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M546.9 1182.17c0.8,-0.77 2.55,-1.24 3.61,-0.88 3.02,0.85 4,3.37 3.26,6.23 -0.46,1.92 -1.68,3.64 -3.57,5.19 -1.88,-1.3 -2.85,-2.27 -3.57,-3.37 -1.57,-2.39 -1.98,-5.03 0.27,-7.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1306.78 1161.52c1.07,6.14 -0.88,9.08 -6.09,7.91 -2.81,-0.63 -4.63,-3.38 -3.9,-6.06 1.45,-5.03 5.05,-5.51 9.99,-1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M474.67 1085.21c2.31,-1.51 5.27,-2.71 7.5,-0.45 1.08,1.12 1.42,3.94 0.82,5.53 -1.49,3.99 -5.14,3.87 -9.9,2.95 -4.96,-4.71 -1.03,-6.3 1.57,-8.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M807.89 152c-1.6,-0.39 -3.25,-2.58 -3.85,-4.27 -1,-3.02 0.86,-5.26 4.73,-6.96 4.3,1.29 5.51,3.78 4.91,6.71 -0.55,2.86 -2.68,5.29 -5.8,4.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M855.11 183.43c-3.47,-3.71 -3.93,-6.76 0.02,-8.73 3.43,-1.69 6.86,0.12 7.32,3.89 0.55,4.45 -2.38,5.59 -7.34,4.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M747.76 580.15c3.88,0.12 6.28,3.91 4.65,7.33 -1.96,4.12 -5.21,3.83 -9.36,0.71 -1.09,-5.21 0.24,-8.18 4.71,-8.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1140.62 1329.84c-0.51,2.94 -3.39,4.79 -6.2,4.03 -5.14,-1.4 -5.62,-5.09 -1.8,-10.38 6.74,-1.55 8.84,1.39 8,6.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1145.07 748.55c-4.27,-3.62 -3.21,-6.92 2.56,-9.74 5.81,2.46 7.23,5.61 3.03,9.54 -1.58,1.54 -3.9,1.63 -5.59,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1700.55 1427.17c-0.91,3.01 -3.85,4.11 -6.62,2.83 -3.99,-1.82 -3.71,-5.16 -0.65,-9.4 6.47,-1.13 8.91,1.31 7.27,6.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M957.59 1226.05c-1.22,-6.24 0.89,-8.81 5.93,-7.76 2.87,0.61 4.35,3.43 3.64,6.05 -1.34,4.97 -4.74,5.73 -9.57,1.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M909.93 1391.08c2.25,-0.72 3.78,0.47 4.69,2.41 1.3,2.76 0.72,5.22 -1.88,6.91 -1.05,0.65 -2.47,0.71 -4.93,0.4 -1.67,-1.8 -2.51,-2.95 -2.56,-4.21 -0.16,-3.16 1.98,-4.68 4.68,-5.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1542.38 1773.11c5.25,2.39 6.95,5.35 2.69,9.09 -1.55,1.35 -3.64,1.65 -5.29,0.16 -3.9,-3.54 -2.96,-6.63 2.6,-9.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1188.1 1473.19c3.22,1.94 3.3,6.34 0.2,8.76 -3.63,2.84 -6.3,1 -8.27,-3.88 1.75,-4.85 4.13,-7.2 8.07,-4.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1317.42 888.9c-1.01,1.41 -3.29,2.76 -4.86,2.62 -1.56,-0.12 -3.72,-1.81 -4.24,-3.35 -0.54,-1.6 0.49,-3.8 2.1,-6.07 2.56,-0.23 4.06,-0.43 5.06,0.2 2.58,1.45 3.87,3.94 1.94,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1300.19 880.24c-2.59,-1.52 -3.23,-4.27 -1.52,-6.78 1.02,-1.5 2.87,-2.99 4.55,-3.3 2.87,-0.51 5.16,1.18 5.57,4.23 0.37,2.62 0.23,5.33 0.33,7.96 0,0 0.05,0.06 -1.57,-0.23 -3.53,-0.81 -5.67,-0.91 -7.36,-1.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1913.49 1856.11c-4.74,-1.93 -5.49,-4.74 -2.62,-7.97 1.46,-1.62 3.61,-2.21 5.29,-0.3 2.77,3.17 2.45,5.97 -2.67,8.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1056.83 1766.38c2.74,1.51 3.3,4.07 2.22,6.9 -0.81,2.01 -2.46,3.34 -4.7,3.14 -3.04,-0.29 -4.8,-2.17 -4.87,-5.26 -0.02,-1.22 0.75,-2.49 2.35,-4.52 2.47,-0.63 3.94,-0.81 5,-0.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M359.7 1010.8c1.11,-1.3 3.22,-2.44 4.88,-2.45 2.92,0.01 4.79,2.15 4.83,5.12 0.05,2.64 -0.57,5.3 -2.28,7.5 -3.2,-1.24 -5.37,-1.66 -6.65,-3.03 -1.91,-1.92 -2.85,-4.74 -0.78,-7.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1249.66 368.18c-0.9,-2.75 0.61,-5.55 3.35,-6.27 4.96,-1.28 7.06,1.54 6.45,7.59 -4.75,4 -8.15,3.48 -9.8,-1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M956.41 1298.44c-0.08,3.04 -2.23,5.3 -5.27,4.86 -5.37,-0.74 -6.25,-4.13 -2.6,-9.52 5.08,-1.01 8.05,0.22 7.87,4.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M660.72 489.47c0.29,1.58 -0.6,4.02 -1.79,5.21 -2.15,2.19 -5.17,1.72 -7.22,-0.1 -1.29,-1.09 -1.47,-3.48 -1.35,-6.53 2.01,-1.7 3.23,-2.42 4.46,-2.62 3.07,-0.4 5.32,1.27 5.9,4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M7.37 1590.74c2.24,1.75 2.46,4.97 0.39,6.91 -3.26,3.04 -5.78,1.03 -7.76,-3.44 1.43,-5.23 4.33,-5.95 7.37,-3.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M163.58 814.79c0.61,-3.01 3.48,-4.72 6.33,-3.86 4.41,1.32 4.66,4.36 0.72,8.54 -5.55,1.6 -7.95,-0.19 -7.05,-4.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M503.39 2250.39c0.96,0.35 2.17,2.07 2.04,3.05 -0.64,5.32 -3.87,6.64 -9.22,3.83 -0.29,-6.16 1.99,-8.76 7.18,-6.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M530.85 1071.87c1.54,-0.65 3.61,-0.06 6.01,1.05 -0.08,2.83 -0.36,5.05 -1.55,6.2 -2.23,2.16 -4.95,1.78 -6.62,-0.84 -1.74,-2.68 -0.52,-5.25 2.16,-6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M212.74 990.87c6.08,-0.67 8.33,1.69 7.32,6.63 -0.46,2.17 -2.32,3.34 -4.39,2.75 -4.48,-1.22 -6.35,-4.03 -2.94,-9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M332.89 1829.04c-0.64,4.87 -4.48,7.66 -8.27,6.07 -4.5,-1.89 -2.23,-5.26 0.68,-9.08 4.66,-1.84 8.27,-2.02 7.6,3.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M928.36 957.88c-2.26,1.97 -5.44,1.67 -7.01,-1.23 -1.7,-3.03 0.27,-5.03 4.26,-6.3 5.29,1.71 6.19,4.55 2.74,7.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M678.14 1017.56c1.8,1.06 2.6,2.88 1.81,4.86 -0.79,2 -2.59,3.06 -4.7,2.65 -2.15,-0.42 -3.01,-2.15 -2.95,-4.31 0.04,-1.92 0.15,-3.86 0.15,-5.85 0.06,0.08 0.31,0.33 0.99,0.76 2.24,1.06 3.56,1.29 4.69,1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M672.47 1014.85c-0.01,0.01 -0.02,0.04 -0.02,0.04 -0.02,-0.04 -0.03,-0.06 0.02,-0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M401.09 1130.53c-0.55,3.87 -3.55,5.51 -7.14,4.23 -4.35,-1.55 -3.72,-4.52 -0.17,-8.28 4.86,-1.28 7.97,-0.54 7.31,4.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M435.02 1026.96c-3.13,-3.91 -2.59,-6.83 0.86,-8.83 2.49,-1.44 5.13,-1.51 6.76,1.32 1.08,1.88 0.55,3.98 -1.17,5.25 -1.54,1.15 -3.43,1.78 -6.44,2.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M584.86 1143.24c-3.84,-3.49 -1.68,-6.96 3.78,-9.41 4.76,1.32 7.22,3.42 4.67,7.27 -2.04,3.13 -5.85,4.55 -8.45,2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1235.41 245.08c-3.06,-0.26 -4.88,-2.67 -3.79,-5.67 1.23,-3.32 3.96,-3.07 7.26,-0.5 1.25,4.27 -0.13,6.42 -3.48,6.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M364.55 512.94c-3.74,2.63 -6.9,4.49 -8.98,0.4 -1.27,-2.55 -0.32,-5.37 2.48,-6.41 4.38,-1.63 7.62,-0.71 6.5,6.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M441.13 2401.03c4.4,1.12 3.97,4.51 0.94,8.66 -5.01,1.28 -7.96,0.13 -7.07,-4.46 0.57,-2.81 3.51,-4.85 6.12,-4.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M466.09 834.91c4.97,1.22 6.74,3.74 4.13,7.28 -2.31,3.09 -5.81,3.59 -8.34,0.63 -3.06,-3.63 0.02,-5.85 4.22,-7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1495.95 1297.07c-4.7,0.42 -4.88,-3.28 -4.17,-8.13 3.6,-3.93 6.72,-4.57 8.84,-0.8 2.17,3.77 -0.32,8.57 -4.66,8.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M185.64 1092.68c2.48,2.65 0.99,5.14 -1.47,6.95 -1.07,0.75 -2.59,0.86 -5.08,0.78 -3.06,-3.11 -3,-5.76 -0.72,-7.92 2.28,-2.14 5.16,-2.05 7.27,0.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M471.29 388.29c4.1,1.19 5.7,3.36 3.73,6.32 -1.78,2.69 -4.86,2.87 -6.79,0.35 -1.95,-2.52 -1.29,-5.2 3.06,-6.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M380.66 1674.96c5.16,-1.25 8.19,-0 7.13,4.65 -0.64,2.74 -3.66,4.78 -6.39,4.09 -4.89,-1.18 -3.62,-4.73 -0.74,-8.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1341.37 645.48c-4.99,-1.72 -5.26,-4.43 -2.72,-7.47 1.39,-1.71 3.58,-1.84 5.16,-0.51 2.34,1.94 1.82,4.43 0.19,6.72 -0.34,0.54 -0.98,0.84 -2.63,1.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1038.8 1134.93c-0.15,-0.98 0.8,-2.86 1.65,-3.21 3.89,-1.5 6.4,-0.29 5.94,5.32 -4.34,3.26 -6.88,2.3 -7.58,-2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1140.26 452.7c-4.16,-1.14 -4.07,-4.44 -0.98,-8.52 4.95,-1.13 7.86,0.14 7.01,4.52 -0.52,2.75 -3.43,4.71 -6.03,4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1403.82 730.04c3.33,-1.01 4.96,0.07 6.04,1.93 1.13,1.84 1.59,4.14 -0.11,5.64 -2.47,2.12 -5.38,1.73 -6.87,-1.11 -0.79,-1.5 -0.12,-3.82 0.94,-6.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1676.67 1459.28c-3.23,0.69 -4.54,-1.33 -3.78,-5.38 2.98,-2.65 5.58,-3.11 7,-0.24 1.46,2.86 -0.49,5.05 -3.22,5.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M626.42 1113.48c2.7,-1.08 5.81,0 6.38,2.82 0.88,4.32 -2.51,5.48 -7.25,5.33 -3.9,-3.9 -2.82,-6.67 0.87,-8.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1197.47 1083.62c-0.16,-2.71 -0.15,-4.13 0.39,-5.39 1.21,-2.99 3.37,-4.34 6.47,-3.05 3.24,1.34 3.7,5.36 0.98,8.74 -2.07,2.53 -4.67,2.51 -7.85,-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M179.94 1772.82c4.34,-0.73 5.94,1.83 4.83,7.12 -3.72,3.17 -6.96,4.79 -9.11,0.48 -1.63,-3.39 0.4,-6.95 4.28,-7.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1486.59 1163.13c-1.11,4.33 -4.1,4.63 -8.21,1.16 -1.49,-5.21 0.12,-7.84 4.41,-7.22 2.83,0.43 4.53,3.32 3.8,6.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1613.18 1831.32c-1.54,5 -4.03,6.53 -7.28,3.55 -2.04,-1.92 -2.55,-5.07 -0.43,-7.02 3.21,-2.99 5.84,-1.17 7.71,3.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1042.15 817.71c-2.59,-0.73 -4.94,-2.57 -4.35,-5.53 0.55,-2.75 3.08,-4.41 5.88,-3.76 1.67,0.38 3,2.05 4.49,4.52 -1.1,4.06 -3.12,5.61 -6.02,4.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M293.66 133.86c-0.68,-1.9 -0.08,-4.1 2.13,-4.7 4.92,-1.36 7.15,1.24 7.01,7.21 -5.23,4.27 -7.68,1.66 -9.14,-2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M213.54 839.54c4.8,2.39 5.53,5.75 4.63,9.28 -0.45,1.64 -2.25,3.87 -3.73,4.18 -2.04,0.41 -3.72,-1.73 -3.63,-3.88 0.12,-2.74 0.91,-5.42 1.45,-8.61 0.06,-0.45 0.04,-1.39 1.28,-0.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1558.96 1851.51c2.82,3.31 1,6.19 -3.63,8.33 -5.2,-1.58 -6.22,-4.33 -3.4,-7.69 1.86,-2.2 5.09,-2.96 7.04,-0.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M199.68 615.3c-1.66,-2.72 -0.81,-5.57 2.17,-6.73 1.65,-0.62 3.8,0.18 6.5,1.36 -0.07,2.84 -0.41,5.13 -1.72,6.21 -2.28,2.01 -5.24,2.04 -6.95,-0.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M687.82 1159.63c-0.96,-5.34 1.31,-7.56 5.21,-7.22 3.08,0.25 4.58,2.94 3.5,5.84 -1.45,3.97 -4.52,4.47 -8.71,1.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1421.83 857.95c1.13,2.9 0.18,5.21 -4.09,6.49 -2.51,-1.47 -4.28,-2.74 -4.81,-4.43 -0.67,-1.98 0.43,-4.12 2.5,-4.96 2.97,-1.22 5.25,0.05 6.4,2.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1711.17 934.91c-4.25,-1.12 -5.26,-3.44 -3.24,-6.28 1.74,-2.44 4.61,-3.43 6.61,-0.57 1.87,2.69 0.45,5.15 -3.37,6.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M537.11 695.98c-4.82,0.85 -8.33,0.38 -7.53,-4.44 0.5,-3.08 3.7,-4.19 6.33,-3.6 4.39,0.94 4.97,3.8 1.2,8.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M818.04 304.15c-2.88,1.19 -5.25,0.06 -6.67,-4.14 0.98,-2.35 1.72,-3.67 2.86,-4.31 2.6,-1.6 5.44,-1.88 6.66,1.57 1.07,2.86 0.12,5.66 -2.86,6.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M777.47 172.7c-3,-3.65 -4.68,-6.79 -0.5,-9.08 3.2,-1.73 6.75,0.25 7.34,4.08 0.64,4.19 -1.53,6.17 -6.84,5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M827.91 2476.52c0.42,5.78 -1.28,8.88 -6.37,6.28 -1.2,-0.59 -2.31,-3.44 -1.92,-4.81 1.24,-3.98 4.31,-4.16 8.3,-1.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M465.02 2020.77c2.47,1.86 2.22,5.11 -0.09,7.08 -2.99,2.57 -6.18,2.6 -8.13,-2.82 2,-4.66 4.67,-6.92 8.22,-4.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1775.59 986.74c-2.12,-2.42 -1.71,-5.24 0.95,-6.75 1.39,-0.8 3.66,0 6.12,1.09 -0.13,2.71 -0.53,4.84 -1.81,6.06 -1.5,1.44 -3.89,1.15 -5.27,-0.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1130.7 1904.93c4,-0.74 5.72,1.8 4.65,6.96 -3.49,3.35 -6.59,4.64 -8.38,0.41 -1.49,-3.39 -0.09,-6.67 3.72,-7.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1945.77 1302.97c-2.1,-2.27 -1.62,-5.23 0.95,-7.01 2.75,-1.9 5.42,-0.52 6.62,2.12 0.73,1.6 0.03,3.84 -1.13,6.39 -2.93,-0.05 -5.23,-0.25 -6.44,-1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1022.58 319.87c-2.54,-3.08 -1.76,-6.2 3.15,-8.33 4.86,1.89 6.19,4.86 3.81,8.25 -1.83,2.49 -5.11,2.32 -6.96,0.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M556.99 679.96c1.29,3.06 -0.42,5.14 -3.3,6 -2.15,0.61 -3.9,-0.43 -4.85,-3.65 1,-2.01 1.89,-3.11 3.05,-3.7 1.96,-1 4.22,-0.74 5.1,1.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M878.84 1507.9c1.08,2.86 0.36,5.71 -2.86,6.52 -3.01,0.78 -5.09,-1.15 -5.99,-4.12 -0.19,-0.63 -0.1,-1.39 0.44,-3.32 4.2,-4.1 6.89,-3 8.42,0.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M778.11 1289.13c-0.84,-2.13 0.67,-3.93 2.59,-4.55 3.93,-1.22 6.22,0.21 5.45,5.63 -3.93,3.54 -6.58,2.72 -8.04,-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1006.48 1510.25c3.11,-2.9 6.1,-2.3 8.02,2.85 -1.03,2.36 -1.73,4.01 -2.85,4.3 -1.77,0.56 -4.51,1.04 -5.54,0.1 -2.31,-2.06 -1.81,-5.22 0.37,-7.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M756.3 1283.65c-2.29,-2.81 -0.81,-5.17 1.6,-6.95 1.08,-0.75 2.56,-0.91 5.02,-0.8 2.57,2.26 2.97,4.39 1.83,6.27 -2.22,3.58 -6.1,4.24 -8.44,1.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1800.35 1253.9c-2.01,-2.59 -1.05,-4.9 1.44,-6.53 1.02,-0.65 2.4,-0.73 4.76,-0.56 1.33,2.3 2.3,4.53 1.63,5.78 -2,3.54 -5.76,3.99 -7.83,1.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1699.01 1480.57c0.57,-0.96 1.89,-1.94 2.93,-2.07 3.29,-0.44 4.51,2.03 5.05,4.68 0.23,1.17 -0.41,2.5 -1.72,4.41 -2.29,0.4 -3.76,0.48 -4.68,-0.2 -2.3,-1.72 -3.14,-4.16 -1.58,-6.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M734.7 203.71c2.8,-1.07 5.14,-0.52 6.42,3.79 -1.53,2.51 -2.85,4.19 -4.54,4.86 -1.97,0.72 -4.08,-0.26 -4.88,-2.31 -1.2,-3 0.19,-5.21 3,-6.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M315.45 1579.37c0.84,3.22 -1.38,4.98 -4.26,5.49 -2.07,0.36 -3.88,-0.56 -4.74,-3.8 0.93,-2.15 1.63,-3.51 2.79,-4.01 2.67,-1.23 5.41,-0.94 6.22,2.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M712.36 1888.01c-1.52,2.47 -2.85,4.09 -4.59,4.79 -2,0.79 -4.22,-0.12 -4.61,-2.31 -0.31,-1.71 -0.02,-4.38 1.08,-5.35 3.06,-2.65 5.99,-1.81 8.13,2.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M972.98 1478.3c0.61,2.77 -0.27,5.44 -3.08,6.35 -1.62,0.52 -3.6,-0.31 -6.19,-1.63 -0.09,-2.88 0.09,-5.22 1.35,-6.22 3.22,-2.48 7.24,-1.54 7.92,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M515.52 973.04c3.9,-1.4 6.75,-1.15 7.02,2.07 0.34,4.07 -4.73,7.19 -8.31,5.08 -2.7,-1.61 -1.87,-4.38 1.29,-7.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1951.47 700.48c-4.1,-1.23 -5.98,-3.51 -4.14,-6.22 1.66,-2.48 4.98,-2.61 7.02,-0.39 2.15,2.36 1.35,4.91 -2.88,6.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M813.19 1596.36c-1.36,3.99 -3.71,5.97 -6.17,4.4 -2.39,-1.58 -1.94,-5.01 0.02,-7.03 2.3,-2.33 4.65,-1.44 6.16,2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M365.41 1048.47c3.25,-0.48 3.99,2.15 3.17,6.13 -3.2,2.93 -5.64,2.7 -6.6,-0.29 -0.89,-2.69 0.67,-5.44 3.43,-5.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M348.28 124.42c2.79,-1.41 5.81,-0.78 6.36,2.38 0.61,3.47 -2.17,4.4 -5.19,3.93 -0.65,-0.13 -1.24,-0.59 -2.48,-1.95 -0.02,-2.22 0.35,-3.88 1.31,-4.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M922.92 431.13c0.63,-2.18 2.63,-3.49 4.79,-2.37 2.94,1.58 2.99,4.18 0.11,7.46 -4.48,0.15 -5.81,-1.9 -4.9,-5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1089.88 1195.39c1.03,-2.03 2.89,-3.1 4.95,-1.91 0.9,0.52 1.54,2.19 1.64,3.4 0.17,2.22 -1.18,3.78 -4.44,4.37 -2.72,-1.87 -3.11,-3.83 -2.15,-5.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1346.88 896.99c0.13,3.44 -1.78,4.67 -5.77,2.82 -1.45,-4.4 0.3,-5.93 3.52,-5.52 0.88,0.13 2.24,1.73 2.25,2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M955.78 1161.12c0.37,-5.25 2.76,-6.62 6.42,-4.53 1.78,1.03 2.48,3.34 1.16,5.01 -1.86,2.33 -4.51,2.18 -7.58,-0.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M558.11 1061.18c1.01,2.75 -0.58,5.53 -3.44,5.89 -3.13,0.38 -4.23,-2.21 -3.52,-6.31 3.32,-2.84 5.89,-2.53 6.95,0.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1058.39 2100c3.08,-0.37 4.16,2.22 3.46,6.29 -3.27,2.94 -5.73,2.32 -6.75,-0.44 -1.04,-2.71 0.52,-5.5 3.29,-5.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1453.15 912.59c-0.78,0.19 -2.27,-0.94 -2.67,-1.81 -0.89,-2.01 0.16,-3.68 1.78,-4.88 0.47,-0.36 1.19,-0.34 2.6,0.18 1.81,3.46 1.49,5.79 -1.71,6.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M631.73 97.14c-2.13,0.55 -4.36,-0.47 -4.79,-2.7 -0.66,-3.6 1.7,-4.62 5.89,-3.96 2.99,3.58 2.25,5.77 -1.1,6.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M680.82 463c-1.02,-0.55 -1.6,-1.92 -2.11,-4.26 1.44,-1.84 2.56,-2.82 3.73,-2.85 3.03,-0.08 5.19,1.5 4.45,4.78 -0.74,3.36 -3.39,3.73 -6.08,2.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M823.96 384.27c-2.79,0.94 -5.92,-0.42 -6.27,-3.37 -0.37,-3.24 2.45,-4.36 6.69,-3.65 3.06,3.37 2.66,5.98 -0.42,7.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1226.48 520.46c-3.96,1.27 -6.37,0.35 -6.9,-2.62 -0.41,-2.01 1.2,-3.85 3.22,-4.07 4.22,-0.45 5.75,1.82 3.68,6.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M433.27 314.73c1.85,-1.52 4.05,-1.08 5.07,1.21 1.33,3.01 -0.02,5.16 -4.1,6.2 -3.29,-2.74 -3.54,-5.32 -0.98,-7.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1482.2 1555.04c-1.46,-4.37 0.27,-5.92 3.51,-5.47 0.97,0.15 2.32,1.71 2.36,2.7 0.1,3.54 -1.97,4.52 -5.87,2.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1128.16 1664.01c2,-0.81 4.23,0.15 4.87,2.27 0.93,3.06 -0.73,5.1 -4.93,5.98 -3.94,-3.48 -4.3,-6.46 0.07,-8.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M830.32 420.23c-2.11,-2.24 -1.18,-4.6 2.72,-6.13 3.9,1.13 5.59,3.18 3.84,5.85 -1.6,2.41 -4.7,2.27 -6.56,0.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M845.58 588.16c-4.1,-1.2 -5.65,-3.22 -3.44,-6.13 1.39,-1.82 3.86,-1.84 5.51,-0.34 2.62,2.27 2.22,4.58 -2.07,6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1188.64 668.03c-0.66,2.09 -2.58,3.5 -4.64,2.38 -2.8,-1.56 -2.6,-4.16 0.09,-7.29 4.47,-0.24 5.45,1.89 4.55,4.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M251.57 821.82c1.24,-0.06 2.52,0.6 4.49,2.11 0.07,4.32 -2.01,5.82 -4.94,5.4 -2,-0.23 -3.49,-1.87 -3.54,-4.05 -0.06,-2.62 1.96,-3.34 4,-3.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1076.62 1858.21c2.38,1.52 2.2,4.84 0.11,6.82 -2.2,2.14 -4.59,1.65 -6.18,-2.48 1.3,-3.95 3.56,-5.93 6.07,-4.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1186.35 1531.1c-0.64,2.13 -2.61,3.35 -4.68,2.21 -2.72,-1.54 -2.99,-4.01 -0.08,-7.21 4.32,-0.1 5.65,1.95 4.76,5.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M758.56 1067.76c-3.93,1.04 -6.47,0.24 -6.69,-2.95 -0.17,-2.39 2,-3.54 4.12,-3.27 3.08,0.35 4.59,2.23 2.57,6.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M920.45 1550.22c0.41,0.85 -0.01,2.77 -0.71,3.36 -3.33,2.8 -5.72,1.32 -7.2,-3.3 3.33,-3.64 6.14,-3.98 7.91,-0.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M628.23 849.38c0.02,-0.01 0.04,0 0.04,0l0.02 0.03c-0,-0.03 -0.04,-0.04 -0.06,-0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M628.29 849.42c0.11,0.11 0.18,0.46 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M631.2 840.5c1.98,-0.43 4.13,0.54 4.7,2.79 0.81,3.16 -1.23,4.99 -3.84,5.96 -1.2,0.45 -2.62,0.14 -3.76,0.12 -0.06,-0.16 -0.15,-0.42 -0.25,-0.82 -0.78,-4.81 0,-7.42 3.15,-8.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M777.87 602.19c0.39,3.29 -2.32,4.3 -6.41,3.52 -2.89,-3.36 -2.56,-5.98 0.44,-6.99 2.75,-0.95 5.64,0.58 5.98,3.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M843.57 340.72c-0.17,-0.88 0.97,-2.6 1.86,-2.93 3.28,-1.17 4.78,0.57 4.35,4.72 -3.69,2.51 -5.7,1.44 -6.21,-1.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M389.43 1223.46c3.27,0.87 3.66,3.62 3.3,6.39 -0.14,1.24 -1.17,2.41 -3.34,4.65 -5.69,0.76 -7.58,-1.61 -7.15,-5.64 0.39,-3.68 3.96,-6.26 7.19,-5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1172.42 1584.81c4.79,1.59 10.42,0.08 9.17,6.48 -0.8,4.32 -4.59,3.94 -7.85,4.02 -0.98,0.03 -1.97,-0.11 -3.14,-0.99 -0.23,0.78 -0.51,1.6 -0.82,2.51 -2.53,8.3 -4.59,15.01 -7.52,21.28 -4.92,10.62 -9.56,21.28 -22.82,24.83 -6.37,1.72 -11.98,6.62 -17.98,9.98 -3,1.61 -6.23,4.38 -9.17,4.19 -7.37,-0.54 -13.27,2.98 -19.75,5.32 -10.99,3.95 -22.11,7.67 -33.39,10.76 -17.35,4.75 -31.89,-4.74 -28.88,-25.51 0.93,-6.23 1.19,-12.62 4.79,-18.07 3.19,-4.89 3.84,-10.27 4.64,-15.87 1.94,-13.83 4.1,-27.58 3.97,-41.57 -0.02,-7.11 1.05,-14.13 5.08,-20.07 8.71,-12.77 18.94,-23.77 34.11,-28.96 5.91,-2.07 12.06,-4.12 17.01,-7.71 8.47,-6.08 16.84,-5.2 25.67,-2.6 14.28,4.25 24.86,14.15 35.52,23.87 1.95,1.76 4.04,4.39 4.39,6.89 1.98,13.52 9.3,26.34 5.86,42.45 0.33,-0.43 0.65,-0.85 1.11,-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1165.29 714.49c4.15,1.56 4.14,4.43 0.67,8.39 -5.42,-0.02 -7.14,-2.17 -5.44,-6.23 0.88,-2.11 2.66,-2.97 4.76,-2.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1140.75 941.73c-0.03,0.14 0.01,0.15 0.55,1.78 0.88,2.91 1.55,4.21 1.37,5.42 -0.34,2.69 -1.37,5.26 -4.79,4.55 -3.72,-0.71 -3.27,-3.79 -2.21,-6.02 1.12,-2.28 3.37,-3.96 5.08,-5.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1928.29 923.33c-2.14,-2.19 -1.38,-4.55 2.65,-6.1 3.91,1.1 5.86,3.16 4.07,5.82 -1.56,2.34 -4.76,2.27 -6.72,0.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M949.6 221.33c-0.47,-2 1.21,-3.76 3.23,-3.95 4.07,-0.33 5.85,1.65 3.83,6.58 -3.91,1.06 -6.42,0.24 -7.06,-2.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1376.98 678.47c-1.59,-0.34 -2.75,-2.45 -3.85,-5.14 2.15,-2.04 4.11,-3.4 5.7,-2.99 1.47,0.36 3.5,2.49 3.52,3.93 0.04,3.17 -2.58,4.77 -5.38,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M347.46 440.47c-0.67,1.03 -1.51,2.03 -2.51,3.08 -4.15,1.77 -7.42,2.66 -10.73,3.05 -21,2.47 -21,2.44 -13.69,-20.95 -0.37,-0.06 -0.77,-0.09 -1.18,-0.22 -1.33,-3.04 -2.25,-4.95 -3.64,-6.41 -2,-2.06 -3.99,-4.15 -2.5,-7.18 1.79,-3.59 5.27,-4.36 8.81,-3.77 4.38,0.76 4.94,4.18 4.39,7.89 -0.35,2.49 -0.7,4.92 0.07,7.52 0.81,-0.07 1.68,-0.06 2.69,-0.03 5.13,0.28 8.57,0.94 13.26,1.7 -0.12,-0.21 -0.26,-0.42 -0.36,-0.65 4.09,-0.93 5.08,1.06 4.91,3.45 0.38,0.45 0.73,0.93 1,1.47 0.17,0.01 0.15,0.32 0.67,1.57 0.13,-0.25 0.21,-0.5 0.37,-0.75 3.82,5.42 2.5,8.94 -1.56,10.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M407.48 805.81c0,0 -0.02,0.05 -0.02,0.08 0.01,-0.04 0.02,-0.07 0.02,-0.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M405.85 811.37c-0.02,-1.83 1.06,-3.7 1.61,-5.48 0.01,0.09 0.17,0.22 1.06,0.59 2.29,1.28 3.53,1.89 4.3,2.83 1.33,1.63 1.55,3.55 0.16,5.32 -1.32,1.63 -3.31,2.8 -5.02,1.57 -1.22,-0.95 -2.11,-3.14 -2.11,-4.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M953.4 1354.43c-0.71,0.67 -2.68,0.9 -3.38,0.39 -2.69,-1.9 -2.39,-4.11 1.3,-6.22 3.77,1.43 4.54,3.51 2.08,5.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M550.18 1255.18c0.72,2.14 -0.58,4.01 -2.69,4.41 -3.2,0.57 -4.56,-1.45 -4.01,-5.54 3.43,-2.47 5.7,-1.88 6.71,1.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M887.15 2207.09c-1.12,-3.93 -0.2,-6.35 2.61,-6.93 1.95,-0.45 3.72,1.14 3.89,3.16 0.35,4.12 -1.76,5.77 -6.5,3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1190.28 924.18c0.22,2.58 -1.9,3.73 -4.07,3.42 -3.2,-0.44 -4.55,-2.51 -2.48,-6.64 4.17,-1.37 6.35,-0.04 6.56,3.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M656.84 529.18c-0.36,5.24 -2.6,6.97 -6.33,4.68 -1.73,-1.06 -2.34,-3.48 -1.12,-5.13 1.84,-2.48 4.43,-2.32 7.45,0.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1208.48 987.35c5.09,0.11 6.75,2.25 5.16,6.14 -0.82,1.96 -2.58,3.1 -4.61,2.31 -4.11,-1.58 -3.63,-4.58 -0.55,-8.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M321.06 1201.78c0.28,-1.29 2.84,-3.33 4.02,-3.14 4.22,0.76 4.52,3.71 1.47,7.74 -4.12,0.13 -6.08,-1.66 -5.49,-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M435.92 1112.93c1.83,-0.48 3.84,-0.16 6.44,1.07 -0.03,4.5 -2.31,5.81 -5.27,5.56 -2.04,-0.15 -3.92,-1.42 -3.72,-3.71 0.12,-1.08 1.47,-2.65 2.55,-2.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1424.75 719.84c0.56,-0.17 1.17,-0.29 1.91,-0.27 3.72,2.84 6.37,4.71 9,6.69 2.95,2.2 4.56,4.95 2.18,8.47 -2.38,3.5 -7.23,4.3 -10.39,1.32 -2.13,-2.07 -3.46,-5.12 -5.53,-9.33 -0.28,0.39 -0.56,0.81 -0.92,1.22 -1.66,-0.22 -2.34,-0.52 -3.66,-1.92 -0.06,0.23 -0.16,0.47 -0.36,0.65 -1.17,-1.63 -1.44,-2.89 -1.15,-3.65 -0.21,-0.62 -0.37,-1.28 -0.48,-2.17 4.91,-6.53 5.21,-6.68 9.4,-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1195.66 1287.99c0.76,-2 2.52,-2.33 5.09,-0.57 0.48,3.06 -0.56,4.52 -2.65,4.46 -2.23,-0.14 -3.2,-1.79 -2.44,-3.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M851.7 1715.01c1.5,2.05 0.34,3.67 -2.83,4.47 -2.71,-2.07 -2.74,-3.98 -0.55,-5.13 0.83,-0.43 2.85,-0.05 3.38,0.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1105.48 1285.76c3.13,2.96 2.47,5.05 -0.56,6.05 -0.77,0.21 -2.55,-0.87 -2.91,-1.76 -0.8,-2.07 0.37,-3.58 3.46,-4.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M625.34 1166.13c0.43,0.8 -0.06,2.81 -0.79,3.35 -1.97,1.47 -3.69,0.69 -4.4,-2.68 2.15,-2.73 4.05,-2.79 5.19,-0.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M326.59 239.57c2.11,0.8 2.31,2.8 0.52,5.6 -3.18,0.43 -4.84,-0.63 -4.72,-2.94 0.17,-2.47 2.03,-3.48 4.2,-2.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M275.27 1099.21c0.61,0.22 1.16,2.26 0.81,3.05 -0.83,1.96 -2.61,2.36 -5.24,0.72 -0.45,-4.52 1.91,-4.63 4.42,-3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1333.74 847.08c0.87,0.23 2,1.92 1.88,2.8 -0.4,2.43 -2.21,3.01 -5.03,1.31 -0.4,-3.31 0.81,-4.78 3.15,-4.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1477.61 903.78c-0.85,-0.25 -1.95,-1.97 -1.79,-2.88 0.37,-2.43 2.15,-3.06 5.02,-1.3 0.36,3.31 -0.87,4.78 -3.22,4.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1060.71 1455.54c0.63,-2.17 2.15,-3.44 4.43,-3.02 3.7,0.71 3.62,3.19 1.12,6.9 -4.34,0.75 -6.68,-0.07 -5.55,-3.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1013.91 1321.16c1.4,1.95 0.33,3.54 -2.73,4.37 -2.64,-2.04 -2.56,-3.87 -0.5,-5.02 0.79,-0.4 2.75,-0.05 3.23,0.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1657.36 997.89c0.14,-0.77 1.89,-1.67 2.79,-1.57 2.22,0.3 3.1,1.79 1.17,4.67 -3.08,0.33 -4.46,-0.89 -3.96,-3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1776.27 1228.84c-0.26,-4.1 0.48,-6.89 4.26,-5.97 2.3,0.58 3.15,2.44 2.75,4.64 -0.64,3.97 -3.38,3.45 -7.01,1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1224.31 922.01c-1.85,-2.99 0.05,-4.67 4.04,-5.77 3,2.69 3.63,5.09 0.74,6.95 -1.86,1.22 -3.65,0.7 -4.78,-1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M91.68 654.73c2.05,-2.47 3.82,-2.72 4.93,-0.62 0.39,0.72 -0.07,2.62 -0.78,3.12 -1.8,1.3 -3.48,0.62 -4.15,-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1819.34 2182.26c2.87,-3.33 5.18,-3.52 6.57,-0.34 0.34,0.91 -0.07,2.84 -0.82,3.43 -2.6,2.06 -4.72,1.12 -5.74,-3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1410.04 994.44c2.34,2.17 2.02,4.35 -2.16,5.62 -2.51,-1.95 -2.87,-3.83 -1.24,-5.32 0.72,-0.63 2.81,-0.89 3.4,-0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1119.19 955.53c-0.37,0.88 -1.92,1.79 -2.88,1.75 -3.54,-0.12 -3.41,-2.74 -1.81,-6.05 3.55,0.1 6.15,0.93 4.69,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M668.71 852.82c-2.56,-2.02 -2.57,-3.87 -0.52,-5.01 0.7,-0.41 2.6,0.06 3.1,0.75 1.27,1.87 0.61,3.54 -2.59,4.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M690.58 861.48c0.8,-0.43 2.73,-0.04 3.19,0.65 1.39,1.96 0.46,3.55 -2.72,4.33 -2.67,-2.03 -2.46,-3.85 -0.47,-4.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M494.8 884.95c-0.78,-0.22 -1.85,-1.95 -1.7,-2.76 0.42,-2.32 2.25,-2.95 4.99,-1.35 0.19,3.18 -1,4.68 -3.29,4.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1673.08 1518.8c-3.11,0.64 -4.57,-0.39 -4.41,-2.57 0.15,-2.22 1.78,-3.36 3.88,-2.57 1.97,0.73 2.35,2.51 0.54,5.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M786.11 940.91c0.5,0.85 0.94,1.75 1.35,2.94 5.94,19.99 3.43,25.9 -12.58,34.09 -5.11,2.6 -10.13,3.37 -17.65,2.73 0.33,0.17 0.71,0.35 1.04,0.53 -5.8,0.7 -11.12,1.67 -12.6,-3.04 -1.24,-0.63 -2.47,-1.38 -3.8,-2.23 -7.17,-3 -10.13,-6.66 -7.8,-13.24 4.21,-11.89 11.3,-21.32 23.91,-28.01 0.11,-0.08 0.25,-0.14 0.35,-0.2 -0.13,-0.12 -0.29,-0.2 -0.43,-0.31 3.49,-8.1 4.53,-14.94 4.1,-21.56 -1.05,-0.73 -2.11,-1.58 -3.21,-2.54 -3.62,-2.4 -5.95,-4.28 -9.36,-6.53 -0.02,0.2 -0.03,0.4 -0.1,0.63 -2.77,1.17 -4.36,2.2 -6.05,2.93 -0.95,0.43 -2.11,0.49 -3.21,0.69 0.15,-1.1 0.09,-2.25 0.47,-3.25 0.81,-2.06 1.8,-4.12 3.41,-6.07 -0.3,-0.73 -0.57,-1.55 -0.78,-2.47 2.38,-5.33 5.91,-8.69 7.76,-12.81 4.26,-9.27 11.42,-14.74 21.87,-19.08 -0.31,-0.16 -0.61,-0.3 -0.91,-0.48 6.04,-1.5 11.84,-4.95 15.78,-0.76 1.44,0.38 2.89,0.97 4.4,1.92 5.36,4.98 9.7,8.97 12.76,14.29 2.79,4.79 2.32,8.73 -0.53,12.93 -1.54,2.21 -3.25,4.29 -4.06,7.57 0.01,0.01 0.03,0.04 0.05,0.06 0.1,-0.06 0.14,-0.1 0.23,-0.16 2.28,1.62 3.51,2.26 4.69,2.93 9.09,4.62 10.09,6.49 3.85,12.34 -0.56,1.27 -1.39,2.62 -2.62,4.17 -1.63,1.49 -2.84,1.79 -5.92,1.97 0.35,0.2 0.72,0.36 1.04,0.57 -5.81,2.51 -10.47,2.69 -11.76,-2.29 -1.14,-0.62 -2.3,-1.36 -3.54,-2.19 -4.07,-1.54 -6.83,-2.49 -11.22,-2.58 -0.13,0.04 -0.25,0.05 -0.39,0.09 0.37,0.19 0.74,0.34 1.08,0.56 -1.31,6.73 -1.89,12.2 -3.33,17.93 0.73,0.38 1.45,0.79 2.23,1.28 2.79,0.78 4.33,1.5 6.92,2.51 -0.06,-0.21 -0.17,-0.4 -0.23,-0.61 3.38,0.75 5.46,2.15 4.79,4.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1453.96 1619.29c0.35,0.86 -0.17,2.74 -0.93,3.37 -2.54,2.16 -4.56,1.29 -5.52,-3.02 2.81,-3.19 5.12,-3.61 6.45,-0.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M993.67 689.55c2.46,2.23 2.15,4.54 -2.21,5.84 -2.65,-2.05 -2.99,-4.04 -1.3,-5.54 0.74,-0.68 2.87,-0.89 3.51,-0.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M499.61 968.95c-2.04,-0.75 -2.38,-2.57 -0.47,-5.23 3.08,-0.52 4.64,0.42 4.5,2.64 -0.2,2.3 -1.95,3.36 -4.03,2.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M731.25 1400.46c2,-2.59 3.81,-2.8 4.92,-0.62 0.44,0.81 0.03,2.76 -0.66,3.29 -1.97,1.53 -3.49,0.39 -4.26,-2.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M675.97 1699.91c0.11,4.03 -1.57,5.26 -4.5,4.18 -0.43,-0.18 -0.9,-1.11 -0.85,-1.65 0.18,-2.98 1.41,-4.66 5.35,-2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M818.6 517.63c0.29,-0.85 1.93,-1.94 2.76,-1.81 2.35,0.31 2.89,2.05 1.12,4.82 -3.17,0.43 -4.57,-0.69 -3.88,-3.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1123.47 1113.83c-3.01,0.54 -4.54,-0.4 -4.36,-2.54 0.19,-2.25 1.9,-3.32 3.97,-2.6 2.04,0.72 2.18,2.53 0.39,5.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1215.48 815.76c1.95,-1.39 3.59,-0.43 4.37,2.66 -2.11,2.54 -3.94,2.81 -5.09,0.6 -0.41,-0.76 0.03,-2.75 0.72,-3.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M228.9 2156.3c2.64,2.07 2.54,3.88 0.51,5.01 -0.76,0.45 -2.72,0.04 -3.21,-0.68 -1.37,-1.93 -0.5,-3.59 2.7,-4.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M441.54 638.62c-0.45,-3.23 0.88,-4.5 3.1,-3.98 0.82,0.23 1.93,1.87 1.78,2.66 -0.39,2.32 -2.11,2.97 -4.87,1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M887.08 484.27c-0.4,-3.31 0.82,-4.72 3.16,-4.08 0.86,0.26 1.9,1.98 1.76,2.88 -0.35,2.41 -2.1,3.04 -4.92,1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M488.59 1064.32c-3.19,0.6 -4.87,-0.42 -4.68,-2.72 0.18,-2.39 2.06,-3.47 4.21,-2.7 2.11,0.78 2.42,2.69 0.46,5.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1164.59 1502.08c2.05,-2.82 3.76,-2.84 4.77,-0.71 0.36,0.75 -0.22,2.64 -0.96,3.21 -1.77,1.38 -3.45,0.98 -3.8,-2.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M307.15 522.4c0.4,-0.32 2.42,0.5 2.73,1.24 0.73,1.64 0.81,3.56 0.72,5.21 -0.46,-0.14 -1.34,-0.5 -2.24,-1.15 -2.19,-2.13 -3.12,-3.8 -1.21,-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M624.69 2133.57c0.4,2.7 -0.24,5.07 -2.36,3.32 -1.7,-1.39 -0.32,-3.28 2.36,-3.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1354.04 861.2c-0.21,-1.18 -0.46,-2.33 0.13,-4.01 2.19,0.39 2.5,1.57 1.5,2.97 -0.36,0.49 -1.09,0.69 -1.63,1.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M897.09 786.65l0.07 0.05c0,0 -0.06,-0.01 -0.07,-0.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M897.24 786.47c-0.11,0.08 -0.14,0.15 -0.15,0.19 -0.07,-0.1 -0.61,-0.52 -0.61,-0.52 0,0 1.05,0.12 0.76,0.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M1246.45 1371.42c-1.03,1.8 -2.7,2.55 -3.3,1.96 -2.05,-1.84 -0.39,-3.23 1.59,-4.13 0.45,0.39 1.62,0.49 1.7,2.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M368.64 1021.39c0,0 0.01,0.06 0.01,0.08 -0.06,-0.06 -0.05,-0.09 -0.01,-0.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00EEFF",
    fillRule: "nonzero",
    d: "M368.96 1021.78c0.37,0.33 0.21,1.51 0.21,1.51 0,0 -0.46,-1.62 -0.53,-1.82 0.05,0.06 0.13,0.16 0.31,0.31z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSplashAqua1);
export default __webpack_public_path__ + "static/media/homeSplashAqua1.1c0dccc2e57b8ccee3807aa12bd7b840.svg";
export { ForwardRef as ReactComponent };